import React, { useCallback, useEffect, useRef, useState } from "react";
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../../LeftNavigation/DesignerControls/BasicControls.module.css";
import ControlsMap from "../../../Properties/PropertiesConfiguration";
import CollapsibleComponent from "./CollapsibleComponentforBackdrop";
import ToggleBtn from "../../../../ReusableComponents/ToggleBtn/ToggleBtn";
import DragAdvListview from "../../../../Icons/DragAdvListview";
import CrossIcon from "../../../../Icons/RedCross";
import ColorPicker from "../../../../ReusableComponents/ColorPicker/ColorPicker";
import { Button, Row, Col } from "react-bootstrap";
import ColumnPropertiesJson from "../../../Properties/ColumnPropertiesJson";
import { createUniqueId, decryptMessage, encrypt, getFormId } from "../../IFormDesignerLogic";
import ToggleState1 from "../../../../Icons/ToggleState1";
import ToggleState2 from "../../../../Icons/ToggleState2";
import { ThemeJSON } from "../../Theme/ThemeJSON";
import axios from "../../../../axios";
import TableBackdropColumnDetails from "./TableBackdropColumnDetails";
import { regexValidator } from "../../../../Resources/globalFunctions";
import { useTranslation } from "react-i18next";
import ErrorMessageComponent from "../../../../ReusableComponents/ErrorMessageComponent/ErrorMessageComponent";
import { fetchTableChildren } from "../../RequestLogic";
import PrimaryButton1 from "../../../../Icons/PrimaryButton1";
import SecondaryButton from "../../../../Icons/SecondaryButton";
import TextButton from "../../../../Icons/TextButton";
import { DatePickers } from "./Datepicker";
import moment from "moment/moment";
import { useMediaQuery } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import cloneDeep from "lodash-es/cloneDeep";
import ImageUploadBtn from "../../../../ReusableComponents/ImageUploadBtn/ImageUploadBtn";
import { GetStateFromData } from "../../../CustomHooks/CustomHooks";
import { recursiveJsonReader1, validateSqlQuery } from "../../ApplicationAPI/applicationApi";
import { updateStateInRedux, useDispatch } from "../../../../Redux/index.js";

function isFloat(num) {
  return Number.isFinite(num) && !Number.isInteger(num);
}

function returnAvailableWidth(substractFrom, availableWidth) {
  let width = substractFrom - availableWidth;

  if (width < 0) {
    width = 0;
  } else {
    width = isFloat(width) ? width?.toFixed(2) : width;
  }

  return width;
}

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 200,
    color: "#fff"
  }
}));

function TableBackdrop(props) {
  const matches = useMediaQuery("(min-width: 1181px)");
  const { t } = useTranslation(["styles", "translation"]);

  const contexts = GetStateFromData(props.containerId);

  const {
    updateJson,
    showAlertConfirmNotifications,
    openCanvasForSubform,
    maskingKeys,
    dataObjectsContent,
    activePage,
    activeSubForm,
    microFrontendData,
    formState2,
    setIsTableBackdropOpen,
    wizard_type_step,
    wizard_type_subStepIndex,
    wizard_type_subChildMenuIndex,
    setCurrentMappedDO,
    currentMappedDO
  } = contexts.contexts;

  const translationStyles1 =
    window?.psh_configs?.selectedLanguage === "ar" ||
    window?.psh_configs?.selectedLanguage === "ar-SA";
  const { updatedComponentInFormState } = updateJson;
  const dispatch = useDispatch()
  const toggle_defaults = {
    ...(props?.data?.elem_type === "table" && { "ManualInput": "true" })
  }

  const [mandatoryErrors, setMandatoryErrors] = useState({ columnName: false, columnType: false });
  const [propertiesJson, setPropertiesJson] = useState(props.selectedColumn ? { ...toggle_defaults, ...props.selectedColumn.style }  : {});
  const [selectedColumn, setSelectedColumn] = useState(props.selectedColumn ? cloneDeep(props.selectedColumn) : {});
  const [columnsStyle, setColumnsStyle] = useState(
    props.columnsStyle && props.columnsStyle !== null ? props.columnsStyle : {}
  );
  const [columnNamesList, setColumnNamesList] = useState(props.columnNamesList);
  const [errorMessageId, setErrorMessageId] = useState(false);
  const [draggedOptionPosition, setDraggedOptionPosition] = useState();
  const [optionAdditionType, setOptionAdditionType] = useState(
    props?.selectedColumn?.style?.addOptionsMethod === "database" ? "Fetch from database" : "Create manually"
  );
  const [customState, setCustomState] = useState();
  const [availableWidth, setAvailableWidth] = useState(0);
  const [disableButton, setDisableButton] = useState(true);
  const [currentColumnWidth, setCurrentColumnWidth] = useState(
    props?.selectedColumn?.style?.ColumnWidth ? props.selectedColumn.style["ColumnWidth"].replace("%", "") : ""
  );
  const [sessionOption, setSessionOption] = useState("")

  const modalOpenedFrom = useRef(props?.selectedColumn?.from || "new");
  let widthType = "%";
  let widthValue = "percentage";
  let checkAvailableWidth = true;

  const [minDateClear , setMinDateClear] = useState(false);
  const [maxDateClear , setMaxDateClear] = useState(false);

  if (
    props &&
    selectedColumn &&
    selectedColumn.style &&
    selectedColumn.style.columnWidth &&
    selectedColumn.style.columnWidth !== null
  ) {
    if (selectedColumn.style.columnWidth.includes("px")) {
      widthType = "px";
      widthValue = "pixel";
    }
  }

  if(typeof props?.selectedColumn?.style?.Query === "string" && (props?.selectedColumn?.style?.Query?.includes(" ") || props?.selectedColumn?.style?.Query?.toLowerCase()?.includes("select"))) {
    props.selectedColumn.style.Query = encrypt(props?.selectedColumn?.style?.Query);
  }
  if(typeof props?.selectedColumn?.style?.DBQuery === "string" && (props?.selectedColumn?.style?.DBQuery?.includes(" ") || props?.selectedColumn?.style?.DBQuery?.toLowerCase()?.includes("select"))) {
    props.selectedColumn.style.DBQuery = encrypt(props?.selectedColumn?.style?.DBQuery);
  }
  if(typeof props?.selectedColumn?.style?.MasterQuery === "string" && (props?.selectedColumn?.style?.MasterQuery?.includes(" ") || props?.selectedColumn?.style?.MasterQuery?.toLowerCase()?.includes("select"))) {
    props.selectedColumn.style.MasterQuery = encrypt(props?.selectedColumn?.style?.MasterQuery);
  }
  
  const [associatedFieldData, setAssociatedFieldData] = useState(new Map());
  const [associatedField, setAssociatedFieldKeys] = useState([]);
  const [columnPropertiesChanged, setColumnPropertiesChanged] = useState(false);
  const [complexField, setComplexFieldKeys] = useState([]);
  const [bufferToCheck, setBufferToCheck] = useState({});
  const [currentAssociatedFieldData, setCurrentAssociatedFieldData] = useState([])

  const [minDate, setMinDate] = useState();
  const [maxDate, setMaxDate] = useState();

  const isPropertyAllowed = (property, isCalledFromFunction, columnType1 = propertiesJson.ColumnType) => {
    let shouldDisable = false;
    const isKeyMaskingOrShowTotal = property === "ColumnMasking" || property === "ShowTotalListview";
    const isAlignment = property === "ColumnValuesAlignment";
    const isNTextMapped = (propertiesJson.complexFieldType === "NText" && property === "EnableSearch") || (propertiesJson.complexFieldType === "NText" && isCalledFromFunction);
    const propertiesToDisable = [];
    const columnType = propertiesJson.controlName ?? columnType1;

    switch (columnType) {
      case "textbox":
        shouldDisable = isNTextMapped || (property === "ColumnMasking" && propertiesJson.complexFieldType === "Boolean");
        if (property === "ColumnType" || property === "AssociatedField")
          propertiesToDisable.push(...["ColumnMasking"]);
        break;

      case "textarea":
        shouldDisable =
          isNTextMapped || property === "ColumnMasking" ||
          (property === "TableTextAreaHeight" && props?.data?.elem_type !== "table")
        if (property === "ColumnType")
          propertiesToDisable.push(
            ...[
              "ColumnMasking",
              ...(props?.data?.elem_type !== "table" ? ["TableTextAreaHeight"] : [])
            ]
          );
        break;

      case "richtexteditor":
        shouldDisable =
          isNTextMapped || property === "ColumnMasking" ||
          (property === "TableTextAreaHeight" && props?.data?.elem_type !== "table") || property === "EnableSearch" || property === 'VisibleOnTable'
        if (property === "ColumnType")
          propertiesToDisable.push(
            ...[
              "ColumnMasking",
              ...(props?.data?.elem_type !== "table" ? ["TableTextAreaHeight"] : [])
            ]
          );
        break;

      case "button":
        shouldDisable =
          isKeyMaskingOrShowTotal ||
          isNTextMapped || 
          property === "AllowDuplicate" ||
          property === "EnableSearch" ||
          property === "SortingType" ||
          property === "AssociatedField";

        if (property === "ColumnType")
          propertiesToDisable.push(
            ...[
              "ColumnMasking",
              "ShowTotalListview",
              "AllowDuplicate",
              "EnableSearch",
              "AssociatedField",
              "complexFieldName",
              "associatedControlId",
              "complexFieldType",
              "complexFieldVariableLength",
              "complexFieldVariablePrecision",
              "MaxLength",
              "AllowAlphabets",
              "AllowNull",
              "AllowSpaces",
              "AllowSpecialChars",
              "AllowNumbers",
              "MinValue",
              "MaxValue",
              "SortingType"
            ]
          );
        break;

      // same conditions for these controls
      case "radio":
      case "combo":
      case "picklist":
        shouldDisable = isNTextMapped || isKeyMaskingOrShowTotal;
        if (property === "ColumnType")
          propertiesToDisable.push(...["ColumnMasking", "ShowTotalListview"]);
        break;

      case "listbox":
        shouldDisable = isNTextMapped || isKeyMaskingOrShowTotal || property === "EnableSearch" || property === "SortingType";
        if (property === "ColumnType")
          propertiesToDisable.push(...["ColumnMasking", "ShowTotalListview", "EnableSearch", "SortingType"]);
        break;

      case "datepick":
      case "datetimepick":
        const isAdv = props?.data?.elem_type?.toLowerCase() === "advancelistview";
        shouldDisable = isNTextMapped || isKeyMaskingOrShowTotal || (isAdv && property === "SortingType") || property === "EnableSearch";

        if (property === "ColumnType") {
          propertiesToDisable.push(...["ColumnMasking", "ShowTotalListview", ...(isAdv ? ["SortingType"] : [])], "EnableSearch");
        }
        break;

      case "password": 
        shouldDisable = 
          isKeyMaskingOrShowTotal || 
          property === "AllowDuplicate" ||
          property === "EnableSearch" ||
          property === "SortingType";

        if (property === "ColumnType") {
          propertiesToDisable.push(...["ColumnMasking", "ShowTotalListview","EnableSearch","AllowDuplicate","SortingType"])
        }
        break;

      // same conditions for these controls
      case "label":
      case "link":
        shouldDisable =
          isNTextMapped || 
          isKeyMaskingOrShowTotal ||
          property === "AllowDuplicate" ||
          property === "EnableSearch" ||
          property === "SortingType";
        if (property === "ColumnType")
          propertiesToDisable.push(
            ...["ColumnMasking", "ShowTotalListview", "AllowDuplicate", isNTextMapped ? "" : "EnableSearch", "SortingType"]
          );
        break;

      // same conditions for these controls
      case "checkbox":
      case "toggle":
        shouldDisable = isNTextMapped || isKeyMaskingOrShowTotal || property === "AllowDuplicate";
        if (property === "ColumnType")
          propertiesToDisable.push(...["ColumnMasking", "ShowTotalListview", "AllowDuplicate"]);
        break;
    }

    // reseting the value of propertiesToDisable to default
    if (isCalledFromFunction && propertiesToDisable.length) {
      const updatedProperties = {};
      propertiesToDisable.forEach((item) => {
        if(item){
            updatedProperties[item] = ThemeJSON?.tableColumn1?.[item];
        }
      });

      setPropertiesJson((prev) => ({ ...prev, ...updatedProperties }));
    }

    return shouldDisable;
  };

  const fillBuffer = () => {
    const obj = {};
    let length = 0;

    if (props.columnsStyle && props.columnsStyle !== null && props.columnsStyle !== undefined) {
      if (Array.isArray(props.columnsStyle)) {
        length = props.columnsStyle.length;
      } else {
        length = Object.keys(props.columnsStyle).length;
      }

      for (let i = 0; i < length; i++) {
        obj[i] = { toggle: false };
      }
    }

    if (Number.isInteger(props.selectedColumn.columnIndex)) {
      obj[props.selectedColumn.columnIndex] = { toggle: true };
    }

    setBufferToCheck(() => obj);
  };

  const handleDataClearFromOptions = (btnDetails) => {
    setOptionAdditionType(btnDetails.Title);
    if (btnDetails.Title === "Fetch from database") {
      setPropertiesJson((prev) => {
        return {
          ...prev,
          options: []
        };
      });

      handleProperty("addOptionsMethod", "database");
    } else if (btnDetails.Title === "Create manually") {
      handleProperty(ColumnPropertiesJson["dropdown"]["Query"]["field"], "");
      handleProperty("addOptionsMethod", "manually");
    }
  };

  const setAvailableWidthFunction = () => {
    let sum = 0;

    Object.keys(columnsStyle).forEach((columnIndex) => {
      let colStyle = columnsStyle[columnIndex].style;

      setAvailableWidth(() => {
        sum = sum + parseInt(colStyle["ColumnWidth"].replace("%", ""));
        return sum;
      });
    });
  };

  const resetProperties = (setState) => {
    let resetKeys = { isKeyAdded: false };
    if(propertiesJson?.complexFieldType === "NText" && propertiesJson?.EnableSearch === "true") {
      resetKeys = { ...resetKeys, isKeyAdded: true, EnableSearch: "false" };
    }
    if(propertiesJson?.ShowHeaderLabel === undefined) {
      resetKeys = { ...resetKeys, isKeyAdded: true, ShowHeaderLabel: "true" };
    }
    if(propertiesJson?.EnableSearch === "true" && (propertiesJson["ColumnType"] === "datepick" || propertiesJson["ColumnType"] === "datetimepick")) {
      resetKeys = { ...resetKeys, isKeyAdded: true, EnableSearch: "false" };
    }
    // if(propertiesJson?.ShowCellData === undefined) {
    //   resetKeys = { ...resetKeys, isKeyAdded: true, ShowCellData: "true" };
    // }
    if(resetKeys.isKeyAdded) {
      if(setState) {
        setPropertiesJson((prev) => {
          return { ...prev, ...resetKeys };
        });
      } else return resetKeys
    }
    return {};
  }

  useEffect(() => {
    fillBuffer();
    setAvailableWidthFunction();
    resetProperties(true);
  }, []);

  useEffect(() => {
    if (props?.data?.elem_type) {
      if (props.data.elem_type.toLowerCase() === "advancelistview") {
        let associatedMap = new Map();
        let temp = [];
        temp.push("Select");

        if (props?.data?.listviewFrameLayoutJson) {
          recursionMappingForAdvance(props.data?.listviewFrameLayoutJson, associatedMap, temp);
        }

        setAssociatedFieldKeys(temp);
        setAssociatedFieldData(associatedMap);
      } else {
        if ((props.data.dataclass || props.data.style?.MappingId) && dataObjectsContent) {
          const fetchAndMap = async () => {
            await fetchingChildrenMapped2(dataObjectsContent);
            recursionMapping(dataObjectsContent);
          };
          fetchAndMap();
        }
      }
    }
  }, []);

  useEffect(() => {
    setComplexFieldKeysHandler();
  }, [columnsStyle]);

  useEffect(() => {
    for (let cols in columnsStyle) {
      if (columnsStyle[cols].columnIndex === selectedColumn.columnIndex) {
        setDisableButton(false);
      }
    }
  }, [selectedColumn]);

  function setComplexFieldKeysHandler() {
    let tempComplex = [];

    Object.values(columnsStyle).map((column) => {
      if (column?.style?.complexFieldName) {
        tempComplex.push(column?.style?.complexFieldName);
      }
    });

    setComplexFieldKeys(tempComplex);
  }

  const updateOptionAdditionType = (btnDetails) => {
    if (btnDetails.Title === "Fetch from database") {
      if (
        !(
          propertiesJson?.["options"]?.length === 1 &&
          propertiesJson?.["options"]?.[0].label === "Select" &&
          propertiesJson?.["options"]?.[0].value === "Select"
        )
      ) {
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showconformationDialogBox",
          alertContentKey: `${t("translation:LostCreateManually")}`,
          alertTitleKey: `${t("translation:ChangeOptionKey")}`,
          Button1Key: "No",
          Button2Key: "Yes",
          manualordatabase: true,
          handleDataClearFromOptions: handleDataClearFromOptions,
          btnDetails: btnDetails
        });
      } else {
        setOptionAdditionType(btnDetails.Title);
        handleProperty("addOptionsMethod", "database");
      }
    } else if (btnDetails.Title === "Create manually") {
      if (
        propertiesJson[ColumnPropertiesJson["dropdown"]["Query"]["field"]] &&
        propertiesJson[ColumnPropertiesJson["dropdown"]["Query"]["field"]] !== ""
      )
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showconformationDialogBox",
          alertContentKey: `${t("translation:lostDatabaseQuery")}`,
          alertTitleKey: `${t("translation:ChangeOptionKey")}`,
          Button1Key: "No",
          Button2Key: "Yes",
          manualordatabase: true,
          handleDataClearFromOptions: handleDataClearFromOptions,
          btnDetails: btnDetails
        });
      else {
        setOptionAdditionType(btnDetails.Title);
        handleProperty("addOptionsMethod", "manually");
      }
    }
  };

  function recursionMappingForAdvance(jsonData, associatedMap, temp) {
    if (Array.isArray(jsonData)) {
      jsonData.forEach((item, index) => {
        if (item?.children) {
          recursionMappingForAdvance(item["children"], associatedMap, temp);
        }
        if (item?.dataclass && (item?.unBounded === "N" || (item.elem_type === "listbox" && item?.unBounded === "Y"))) {
          associatedMap.set(item?.dataclass, {
            [item?.dataclass]: item?.datamapVariableType,
            controlid: item.id
          });
          temp.push(item?.dataclass);
        }
      });
    } else {
      recursionMappingForAdvance(jsonData["children"], associatedMap, temp);
    }
  }

  const fetchingChildrenMapped2 = useCallback(async (dataContent) => {
    await Promise.all(Object.values(dataContent).map(async (dataC) => {
      if (dataC?.children && dataC["children"]) {
        await fetchingChildrenMapped2(dataC["children"]);
      }
      console.log("dataC", dataC, props.data.dataclass, props?.data?.style?.MappingId);
      if (dataC["VariableName"] === props.data.dataclass || dataC["VariableName"] === props?.data?.style?.MappingId){
        console.log("dataC matched", dataC);
      if (dataC.children === undefined && dataC["MappingInfo"]) {
            console.log("fetching children for", dataC);
            const jsonData = {
              parentTableId: dataC.VariableId,
              treeName: `${dataC.treeName}`,
              status: "1",
              formId: getFormId().toString()
            };
            await fetchTableChildren(jsonData).then((response) => {
              dataC.children = response.data["children"];
            });
        }
      }
    }))
  })

  async function recursionMapping(contentData) {
    Object.values(contentData).map((content) => {
      if (content?.children && content["children"]) {
        recursionMapping(content["children"]);
      }

      if (content["VariableName"] === props.data.dataclass || content["VariableName"] === props?.data?.style?.MappingId) {
        let associatedMap = new Map();
        let temp = [];
        temp.push("Select");

        Object.values(content["children"]).map((columnContent) => {
          associatedMap.set(columnContent["VariableName"], {
            VariableLength: columnContent["VariableLength"],
            VariableType: columnContent["VariableType"],
            VarPrecision: columnContent["VarPrecision"]
          });
          temp.push(columnContent["VariableName"]);
        });

        setAssociatedFieldKeys(temp);
        setAssociatedFieldData(associatedMap);
      }

      if (content["treeName"] === props.data.dataclass || content["VariableName"] === props?.data?.style?.MappingId) {
        let associatedMap = new Map();
        let temp = [];
        temp.push("Select");
        Object.values(content["children"]).map((columnContent) => {
          associatedMap.set(columnContent["VariableName"], {
            VariableLength: columnContent["VariableLength"],
            VariableType: columnContent["VariableType"],
            VarPrecision: columnContent["VarPrecision"],
            treeName: columnContent["treeName"]
          });
          temp.push(columnContent["VariableName"]);
        });

        setAssociatedFieldKeys(temp);
        setAssociatedFieldData(associatedMap);
      } else if (props.data.dataclass && microFrontendData.formPageType !== "Processes") {
        if (!content.children && ((content["VariableName"] === props.data.dataclass) || (content["treeName"] === props.data.dataclass))) {
              const jsonData = {
                parentTableId: props.data?.datamapid,
                treeName: `${props.data.dataclass}`,
                status: "1",
                formId: getFormId().toString()
              };

              fetchTableChildren(jsonData).then((response) => {
                let associatedMap = new Map();
                let temp = [];
                temp.push("Select");

                Object.values(response.data["children"]).map((columnContent) => {
                  associatedMap.set(columnContent["VariableName"], {
                    VariableLength: columnContent["VariableLength"],
                    VariableType: columnContent["VariableType"],
                    VarPrecision: columnContent["VarPrecision"]
                  });
                  temp.push(columnContent["VariableName"]);
                });

                setAssociatedFieldKeys(temp);
                setAssociatedFieldData(associatedMap);
              });
        }
      }
    });
  }

  const decrypt_msg_DefaultState = { GridMasterQuery: "", DBQuery: "", Query: "" }
  const [decrypt_msg, setDecrypt_msg]= React.useState(decrypt_msg_DefaultState);

  async function customDecryptMessage(key, value){
    if (value && value instanceof Promise ) {
      value.then((val)=>{
        decryptMessage(val).then((res)=>{
          setDecrypt_msg(prev => ({ ...prev, [key]: res }));
        })
      }) 
    }
    else{
      const res = await decryptMessage(value);
      setDecrypt_msg(prev => ({ ...prev, [key]: res }));
    }
  }

  useEffect(() => {
    const DBQuery = propertiesJson.DBQuery || props?.selectedColumn?.style?.DBQuery;
    const MasterQuery = propertiesJson.MasterQuery || selectedColumn?.style?.MasterQuery;
    const Query = propertiesJson.Query || props?.selectedColumn?.style?.Query;
    
    if(DBQuery) {
      const isValid = typeof props.selectedColumn.style.DBQuery === "string" || typeof propertiesJson.DBQuery === "string";
      if(isValid) {
        customDecryptMessage("DBQuery", DBQuery);
      } else {
        setPropertiesJson((prev) => {
          return { ...prev, DBQuery: "" };
        });
      }
    }

    if(MasterQuery) {
      const isValid = typeof props.selectedColumn.style.MasterQuery === "string" || typeof propertiesJson.MasterQuery === "string";
      if(isValid) {
        customDecryptMessage("GridMasterQuery", MasterQuery);
      } else {
        setPropertiesJson((prev) => {
          return { ...prev, MasterQuery: "" };
        });
      }
    }

    if(Query) {
      const isValid = typeof props.selectedColumn.style.Query === "string" || typeof propertiesJson.Query === "string";
      if(isValid) {
        customDecryptMessage("Query", Query);
      } else {
        setPropertiesJson((prev) => {
          return { ...prev, Query: "" };
        });
      }
    }
    if(MasterQuery === ""){
      setDecrypt_msg((prev) => ({ ...prev, GridMasterQuery: "" }));
    }
  },[columnsStyle, propertiesJson.DBQuery, propertiesJson.MasterQuery, propertiesJson.Query])

    useEffect(()=>{
      let maskingType = ""
      let maskingLength = ""
      if(propertiesJson?.ColumnMasking === "000-000")
      {
         maskingType = "pin-code";
         maskingLength = "6";
      }
      else if(propertiesJson?.ColumnMasking === "(00) 0000000000"){
        maskingType = "mobile-number";
        maskingLength = "12";
      }
      if (
        propertiesJson?.MaskingType !== maskingType ||
        propertiesJson?.MaskingLength !== maskingLength
      ) {
        setPropertiesJson((prev) => ({
          ...prev,
          MaskingType: maskingType,
          MaskingLength: maskingLength,
        }));
  }
    },[columnsStyle, propertiesJson?.ColumnMasking])

  const [selectedButtonType, setSelectedButtonType] = useState(propertiesJson.ButtonType || "Primary");

  function selectedOptionForButtonType(value) {
    setSelectedButtonType(() => value);
    handleProperty("ButtonType", value);
  }

  function handleComboDate(key, value) {
    setPropertiesJson((prev) => {
      return { ...prev, [key]: value, ["isModify"]: "true" };
    });
    setColumnPropertiesChanged(true);
  }

  const resetColumnWidth = (newWidthType, widthType) => {
    let defaultWidthValue;
    if (newWidthType === "percentage") {
      if (Object.keys(columnsStyle || {}).length <= 10) {
        defaultWidthValue = 10;
      } else if (Object.keys(columnsStyle || {}).length) {
        defaultWidthValue = 100 / Object.keys(columnsStyle || {}).length;
      }
    } else {
      defaultWidthValue = 100;
    }

    Object.keys(columnsStyle).forEach((columnIndex) => {
      const colStyle = columnsStyle[columnIndex].style;
      colStyle.ColumnWidth = `${defaultWidthValue}${widthType}`;
      colStyle.ColumnWidthType = newWidthType;
    });
  };

  function handleCombo(comboId, event) {
    const select = document.getElementById(comboId);
    const propertyName = select.getAttribute("name");
    const optionTag = select.options[select.selectedIndex];

    isPropertyAllowed(propertyName, true, optionTag.value);

    if (propertyName.toLowerCase() === "columntype") {
      const shouldRemoveMaksing = optionTag.value !== "textbox";
      const shouldAddOption = props?.data?.elem_type === "table" && (optionTag.value === "radio" || optionTag.value === "combo");
      const shouldRemoveSearching = optionTag.value === "listbox" || optionTag.value === "button" || optionTag.value === "label" || optionTag.value === "link";
      const shouldAddDate = optionTag.value === "datepick" || optionTag.value === "datetimepick";
      const isRichTextEditor = optionTag.label === 'Richtext Editor';

      const checkboxProperties = {
        VisibleOnTable: "true",
        ShowHeaderLabel: "true",
        ShowTotal: "false",
        EnableSearch: "true",
        AllowDuplicate: "true",
      }

      const checkboxOverridesByColumnType = {
        Select: {},
        browse: { EnableSearch: "false", AllowDuplicate: "false", ShowTotal: "false" },
        textbox: {},
        textarea: isRichTextEditor ? { VisibleOnTable: "false", EnableSearch: "false" } : {},
        richtexteditor: { VisibleOnTable: "false", EnableSearch: "false" },
        datepick: { EnableSearch: "false", ShowTotal: "false" },
        datetimepick: { EnableSearch: "false", ShowTotal: "false" },
        button: { EnableSearch: "false", AllowDuplicate: "false", ShowTotal: "false" },
        radio: { ShowTotal: "false" },
        listbox: {}, 
        combo: { ShowTotal: "false" },
        picklist: { ShowTotal: "false" },
        label: { EnableSearch: "false", AllowDuplicate: "false", ShowTotal: "false" },
        link: { EnableSearch: "false", AllowDuplicate: "false", ShowTotal: "false" },
        checkbox: { AllowDuplicate: "true", ShowTotal: "false" },
        toggle: { AllowDuplicate: "false", ShowTotal: "false" },
      };

      const checkboxOverrides = checkboxOverridesByColumnType[optionTag.value] || {};

      setPropertiesJson((prev) => {
        if(!shouldAddOption && prev.options) {
          delete prev.options;
        };

        if (optionTag.value !== "combo"){
          delete prev?.MasterQuery;
        }

        if(!shouldAddOption && prev.addOptionsMethod) {
          delete prev.addOptionsMethod;
        };

        if(!shouldAddDate && prev.DateFormat) {
          delete prev.DateFormat;
        };

        if(!shouldAddDate && prev.DateFormat) {
          delete prev.DateFormat;
        };

        if(!isRichTextEditor && prev.isRichTextEditor) {
          delete prev.isRichTextEditor;
          delete prev.controlName;
        };

        return {
          ...prev,
          ...checkboxProperties,
          ...checkboxOverrides,
          ...(shouldAddDate && props?.data?.elem_type !== "table" && props?.data?.elem_type !== "listview" ? {
            ["DateFormat"]: optionTag.value ="",
          } : {}),
          ...(shouldRemoveSearching ? { SortingType: "false", EnableSearch: "false" } : {}),
          ...(shouldAddOption
            ? {
                options: [{ label: "Select", value: "Select" }],
                addOptionsMethod: "manually"
              }
            : {}),
            ...(isRichTextEditor ? { controlName: "richtexteditor", isRichTextEditor: "true" } : {}),
          ...(shouldRemoveMaksing ? { ColumnMasking: undefined, ShowTotalListview: undefined } : {})
        };
      });
    }
    if (propertyName.toLowerCase() === "columnwidthtype") {
      const value = event.target.value;

      showAlertConfirmNotifications({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentKey: "Column width type will be changed for all columns and their values will be set to default."
      });

      let propertyValue;
      if (value === "percentage") {
        widthType = "%";
        widthValue = "percentage";
        propertyValue = "10%";
      } else {
        widthType = "px";
        widthValue = "pixel";
        propertyValue = "100px";
      }

      resetColumnWidth(value, widthType);
      setAvailableWidthFunction();

      setPropertiesJson((prev) => {
        return { ...prev, ["ColumnWidth"]: propertyValue, ["ColumnWidthType"]: widthValue };
      });
    } else if (propertyName === "ToggleStates") {
      setCustomState(optionTag.value);

      if (optionTag.value === "On/Off") {
        handleProperty("ToggleState1", "Off");
        handleProperty("ToggleState2", "On");
      } else if (optionTag.value === "Yes/No") {
        handleProperty("ToggleState1", "No");
        handleProperty("ToggleState2", "Yes");
      }

      handleProperty("ToggleStates", optionTag.value);
      return;
    } else if (propertyName === "AssociatedField") {
      const selectedDataType = associatedFieldData.get(optionTag.value);
      setCurrentAssociatedFieldData(selectedDataType || {})

      if (propertiesJson["complexFieldName"] && optionTag.value !== propertiesJson["complexFieldName"] && complexField.includes(propertiesJson["complexFieldName"])) {
        setSessionOption(propertiesJson["complexFieldName"])
      }

      let propJson = {
        ...propertiesJson,
        ["complexFieldName"]: selectedDataType ? optionTag.value : "",
        ["associatedControlId"]: selectedDataType?.[optionTag.value] || "",
        ["complexFieldType"]: selectedDataType?.VariableType || selectedDataType?.[optionTag.value] || "",
        ["complexFieldVariableLength"]: selectedDataType?.VariableLength || "",
        ["complexFieldVariablePrecision"]: selectedDataType?.VarPrecision || ""
      };

      if (
        propJson.complexFieldVariableLength &&
        propJson.complexFieldVariablePrecision &&
        props?.data?.elem_type === "table"
      ) {
        propJson.MaxLength = (
          parseInt(propJson.complexFieldVariableLength) + 1
        ).toString();
      }

      if(propJson.complexFieldType === "NText") {
        propJson["EnableSearch"] = "false";
      }

      if (
        propJson.complexFieldType === "Integer" ||
        propJson.complexFieldType === "Float" ||
        propJson.complexFieldType === "Long"
      ) {
        propJson.AllowAlphabets = "false";
        propJson.AllowNull = "false";
        propJson.AllowSpaces = "false";
        propJson.AllowSpecialChars = "false";
        propJson.AllowNumbers = "true";
      } else if (propJson.complexFieldType === "String" || propJson.complexFieldType === "NText") {
        propJson.AllowAlphabets = "true";
        propJson.AllowNull = "true";
        propJson.AllowSpaces = "true";
        propJson.AllowSpecialChars = "true";
        propJson.AllowNumbers = "true";
        // propJson.MinValue = "";
        // propJson.MaxValue = "";
      } 

      setPropertiesJson((prev) => {
        return { ...propJson };
      });
    } else {
      if (propertyName === "ColumnType" && optionTag.value === "radio") {
        setOptionAdditionType("Create manually");
        handleProperty("addOptionsMethod", "manually");
      }
      handleProperty(propertyName, optionTag.value);
    }
    setColumnPropertiesChanged(true);
  }

  function validateRegex(propertyName, propertyValue, event, inputBoxId) {
    try {
        if (
          event &&
          event.which !== 8 &&
          event.which !== 46 &&
          event.code !== "Tab" &&
          !regexValidator(
            event.key,
            ControlsMap[propertyName]["regexType"]
          )
        ) {
          event.preventDefault();
          setErrorMessageId(inputBoxId);
          showAlertConfirmNotifications({
            ...ControlsMap["customizedAlertNotificationData"],
            open: true,
            alertContentKey: "RegexErrorMessage",
          });
        } else {
          // setErrorMessageId(false);
        }      


      
    } catch (e) {
    }
  }

  async function handleProperty(propertyName, propertyValue, event, inputBoxId, isCheckBoxCase) {
    try {
        checkMandatoryFunction(propertyName, propertyValue);
        if (typeof propertyValue === "string" && propertyValue.toLowerCase() === "textarea" && props.data.controlName === 'listview') {
          setPropertiesJson((prev) => {
            return prev.controlName === "richtexteditor" ? { ...prev, VisibleOnTable: "false", EnableSearch: "false" } : prev;
          });
        }
        if (propertyName.toLowerCase() === "columntooltip") {
          if (propertyValue.trim().length < 1) {
            return;
          }
        }
        if (propertyName === "ColumnName" && columnNamesList.includes(propertyValue)) {
          return;
        } else {
          if (propertyName === "MinValue" || propertyName === "MaxValue") {
            if (
              (propertiesJson?.complexFieldType === "Long" &&
                (parseFloat(propertyValue) > 9223372036854775807 ||
                  parseFloat(propertyValue) < -9223372036854775808)) ||
              (propertiesJson?.complexFieldType === "Integer" &&
                (parseFloat(propertyValue) > 2147483647 || parseFloat(propertyValue) < -2147483648))
            ) {
              showAlertConfirmNotifications({
                open: true,
                showConfirm: "showNotification",
                alertType: "error",
                alertContentKey: "Value is out of range."
              });

              setPropertiesJson((prev) => {
                return { ...prev, [propertyName]: "" };
              });

              return;
            }
          }
          if (propertyName === "MinValue") {
            if (parseFloat(propertyValue) > parseFloat(propertiesJson.MaxValue)) {
              showAlertConfirmNotifications({
                open: true,
                showConfirm: "showNotification",
                alertType: "error",
                alertContentKey: "Min value should not be greater than Max value."
              });

              setPropertiesJson((prev) => {
                return { ...prev, [propertyName]: "" };
              });
              return;
            }
          } else if (propertyName === "MaxValue") {
            if (parseFloat(propertyValue) < parseFloat(propertiesJson.MinValue)) {
              showAlertConfirmNotifications({
                open: true,
                showConfirm: "showNotification",
                alertType: "error",
                alertContentKey: "Max value should not be less than Min value."
              });
              setPropertiesJson((prev) => {
                return { ...prev, [propertyName]: "" };
              });
              return;
            }
          }
          if(propertyName === "ColumnName" && props.data.elem_type === "listview"){
            const controlId = `${props.data.id}_${propertiesJson?.ColumnName}`;
            var currentControlJson = recursiveJsonReader1(props.data.listviewFrameLayoutJson, controlId);
            if(currentControlJson)
              currentControlJson.id = `${props.data.id}_${propertyValue}`
            if(currentControlJson?.style)
              currentControlJson.style.Label = propertyValue
          } 
          if(propertyName === ColumnPropertiesJson["dropdown"]["Query"]["field"] || propertyName === ColumnPropertiesJson["listbox"]["Query"]["field"] || propertyName === "MasterQuery") {
            let err_obj =  await validateSqlQuery(propertyValue)
            
            if(err_obj?.error) {
              showAlertConfirmNotifications({
                showConfirm: "showNotification",
                open: true,
                alertContentKey: `The query contains a syntax error: ${err_obj?.errorMessage} Please review and correct the query.` || "The query contains a syntax error or an invalid WHERE clause. Please review and correct the query.",
                alertType: "error",
                autoHideDuration: 5000,
              });
              event.target.value = decrypt_msg?.[propertyName] || "";
              return;
            }
          }
          setPropertiesJson((prev) => {
            return { ...prev, [propertyName]: propertyValue };
          });
          setErrorMessageId(false);
        }
      setColumnPropertiesChanged(true);
    } catch (e) {}
  }

  function addColumnName(propertyName, propertyValue) {
    setPropertiesJson((prev) => {
      return { ...prev, [propertyName]: propertyValue, ["isModify"]: "true" };
    });
    setColumnPropertiesChanged(true);
    setErrorMessageId(false);
    checkMandatoryFunction(propertyName, propertyValue);
  }

  const handleWidthInput = (e) => {
    const input = e.target;
    if (!input.value) {
      input.value = 0;
    }
    input.value = input.value.replace(/^0+(?=\d)/, "");

    let ColumnWidthType = "";
    if (propertiesJson["ColumnWidthType"]) {
      ColumnWidthType = propertiesJson["ColumnWidthType"];
    } else {
      if (propertiesJson["ColumnWidth"]) {
        if (propertiesJson["ColumnWidth"].includes("%")) {
          ColumnWidthType = "percentage";
        } else if (propertiesJson["ColumnWidth"].includes("px")) {
          ColumnWidthType = "pixel";
        }
      } else {
        ColumnWidthType = "percentage";
      }
    }

    if (input.value.length > 2 && ColumnWidthType === "percentage") {
      input.value = input.value.slice(0, 2);
    }
    if (input.value.length > 3 && ColumnWidthType === "pixel") {
      input.value = input.value.slice(0, 3);
    }
  };

  function handleColumnWidth(propertyName, propertyValue, event, inputBoxId) {
    try {
      let value = propertyValue;

      if (propertyName === "ColumnWidth") {
        if (propertiesJson["ColumnWidthType"]) {
          if (propertiesJson["ColumnWidthType"] === "percentage") {
            value = value + "%";
            widthValue = "percentage";
          } else {
            value = value + "px";
            widthValue = "pixel";
          }
        } else {
          if (widthType === "%") {
            value = value + "%";
            widthValue = "percentage";
          } else if (widthType === "px") {
            value = value + "px";
            widthValue = "pixel";
          }
        }
        setCurrentColumnWidth(value.replace("%", ""));
        setPropertiesJson((prev) => {
          return { ...prev, ["ColumnWidth"]: value, ["ColumnWidthType"]: widthValue };
        });
      }
      setColumnPropertiesChanged(true);
    } catch (e) {
      console.log(e);
    }
  }

  function allowDrop(event) {
    event.preventDefault();
  }

  function handleDrag(event) {
    setDraggedOptionPosition(event.target.getAttribute("optionposition"));
  }

  function handleDrop(event) {
    if (event === "undefined") {
      event.preventDefault();
    } else if (event.target.getAttribute("optionposition")) {
      try {
        let targetPosition = event.target.getAttribute("optionposition");
        let temp_imageDetails = propertiesJson["options"];
        let draggedImage = temp_imageDetails[draggedOptionPosition];

        temp_imageDetails[draggedOptionPosition] = temp_imageDetails[targetPosition];
        temp_imageDetails[targetPosition] = draggedImage;

        setPropertiesJson((prev) => {
          return { ...prev, options: temp_imageDetails };
        });
      } catch (e) {
        console.log("Interchanging image Positions");
      }
    }
  }

  function showError(shouldMofify, labelValueType) {
    // customalert
    if (shouldMofify) {
      showAlertConfirmNotifications({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentKey: "EMPTY_LABEL"
      });
    } else {
      showAlertConfirmNotifications({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentKey: `Option ${labelValueType === "label" ? "Label" : "value"} already exist.`
      });
    }
  }

  function handleOption(action, index, labelValueType, value) {
    if (action === "add") {
      const optionCount = propertiesJson["ColumnType"] === "radio" && props?.data?.elem_type === "table" ? 3 : 99999;

      if (!propertiesJson["options"]) {
        propertiesJson["options"] = [];
      }

      const check = checkForAnyEmptyOption();
      if(check) {
        return false;
      }

      if (propertiesJson["options"].length < optionCount) {
          setPropertiesJson((prev) => {
            return {
              ...prev,
              options: [
                ...propertiesJson["options"],
                { label: "", value: "" }
              ]
            };
          });
      } else {
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: "MAX_SIZE"
        });
      }
    } else if (action === "modify") {
      const shouldMofify = !(propertiesJson.options.some((item, curIndex) => item[labelValueType] === value && curIndex !== index));

      if (shouldMofify) {
        if(value) {
          setPropertiesJson((prev) => {
            return {
              ...prev,
              options: propertiesJson["options"].map((optionDetails, indx) => {
                if (indx === index) {
                  optionDetails[labelValueType] = value;
                }
                return optionDetails;
              })
            };
          });
        } else {
          showError(true);
        }
      } else {
        if(value) {
          showError(shouldMofify, labelValueType);
        } else {
          showError(true);
        }
      }
    } else if (action === "delete") {
      let temp_optionsArray = propertiesJson["options"];
      temp_optionsArray.splice(index, 1);

      setPropertiesJson((prev) => {
        return {
          ...prev,
          options: temp_optionsArray
        };
      });
    }
    setColumnPropertiesChanged(true);
  }

  function optionLabelValueAdditionComponent(key, data) {
    switch (ControlsMap?.[key]?.["type"]?.toLowerCase()) {
      case "checkbox":
        return (
          propertiesJson && (
            <div
              className={[styles.columnTypeToggleParentDiv, styles.textAreaParentDiv1, styles.checkboxParent].join(" ")}
              style={{
                display: "flex !important",
                alignItems: "center !important",
                border: "1px solid #c4c4c4 !important",
                borderRadius: "3px !important",
                padding: "6px 8px !important"
              }}
            >
              <input
                aria-label={"Control Value1"}
                id={ControlsMap[key].label}
                type="checkbox"
                className={`${translationStyles1 ? styles.toggleCheckboxArabic : styles.toggleCheckbox} ${
                  styles.removeWidthInCheckBox
                } ${matches ? "" : styles.checkBoxHeightAddColumns}`}
                checked={propertiesJson && propertiesJson[key] === "true" ? true : false}
                onClick={() => handleProperty(key, propertiesJson[key] === "true" ? "false" : "true")}
              />

              <label
                aria-label={ControlsMap[key].label}
                htmlFor={ControlsMap[key].label}
                className={styles.togglePropertiesCheckboxLable}
              >
                {t(`translation:${ControlsMap[key].label}`)}
              </label>
            </div>
          )
        );

      case "combo":
        return (
          <>
            <div className={styles.columnTypeToggleParentDiv}>
              <span className={styles.leftLabel}>
                {t(`translation:${ControlsMap[key].label}`)}
              </span>

              <div className={styles.columnTypeToggleSelectDiv}>
                <select
                  className={styles.RightLabelSelect1}
                  name={key}
                  id={propertiesJson["ColumnName"] + key}
                  onChange={() => handleCombo(propertiesJson["ColumnName"] + key)}
                >
                  {ControlsMap[key].children.map((optionTagData, optionCount) => {
                    if (ControlsMap[key].children[optionCount].Value) {
                      if (propertiesJson[key] === ControlsMap[key].children[optionCount].Value) {
                        return (
                          <option
                            key={ControlsMap[key].children[optionCount].Value}
                            value={ControlsMap[key].children[optionCount].Value}
                            selected
                          >
                            {t(`translation:${ControlsMap[key].children[optionCount].Title}`)}
                          </option>
                        );
                      } else {
                        return (
                          <option
                            key={ControlsMap[key].children[optionCount].Value}
                            value={ControlsMap[key].children[optionCount].Value}
                          >
                            {t(`translation:${ControlsMap[key].children[optionCount].Title}`)}
                          </option>
                        );
                      }
                    }
                  })}
                </select>
              </div>
            </div>

            {customState === "CustomState" && key === "ToggleStates" ? (
              <>
                <div
                  className={styles.parentDiv2 + " " + styles.columnTypeToggleParentDiv}
                  style={{ marginLeft: "0px" }}
                >
                  <span className={styles.leftLabel + " " + styles.columnTypeToggleLabel}>
                    {t("translation:State1")}
                    <span style={{ color: "red" }}> * </span>
                  </span>

                  <ToggleState1 />

                  <input
                    aria-label={"Control Value2"}
                    type="text"
                    defaultValue={propertiesJson["ToggleState1"]}
                    className={styles.RightLabelSelect1}
                    style={{ float: "none", marginLeft: "1rem" }}
                    onChange={(event) => handleProperty("ToggleState1", event.target.value)}
                  />
                </div>

                <div
                  className={styles.parentDiv2 + " " + styles.columnTypeToggleParentDiv}
                  style={{ marginLeft: "0px" }}
                >
                  <span className={styles.leftLabel + " " + styles.columnTypeToggleLabel}>
                    {t("translation:State2")}
                    <span style={{ color: "red" }}> * </span>
                  </span>

                  <ToggleState2 />

                  <input
                    aria-label={"Control Value3"}
                    type="text"
                    defaultValue={propertiesJson["ToggleState2"]}
                    className={styles.RightLabelSelect1}
                    style={{ float: "none", marginLeft: "1rem" }}
                    onChange={(event) => handleProperty("ToggleState2", event.target.value)}
                  />
                </div>
              </>
            ) : null}
          </>
        );

      case "optionadditiontype":
        return (
          <>
            {propertiesJson && propertiesJson["ColumnType"] !== "picklist" ? (
              <>
                <Row
                  className={[
                    styles.columnOptionAdditonTypeRow,
                    ...(translationStyles1
                      ? [styles.columnOptionAdditonTypeRow_mr]
                      : [styles.columnOptionAdditonTypeRow_ml])
                  ].join(" ")}
                >
                  {ControlsMap[key]?.children?.map((btnDetails, index) => {
                    if (propertiesJson["ColumnType"] === "radio") {
                      return null;
                    } else {
                      return (
                        <Button
                          disableFocusRipple
                          disableRipple
                          tabIndex={0}
                          key={btnDetails.Title}
                          className={[
                            styles.columnOptionAdditonType,
                            optionAdditionType === btnDetails.Title ? styles.columnOptionAdditonTypeSelected : null,
                            "formBuilder-MuiButton-outlined"
                          ].join(" ")}
                          onClick={() => updateOptionAdditionType(btnDetails)}
                        >
                          {t(`translation:${btnDetails.Title}`)}
                        </Button>
                      );
                    }
                  })}

                  {optionAdditionType === "Create manually" ? (
                    <Button
                      disableFocusRipple
                      disableRipple
                      tabIndex={0}
                      className={`formBuilder-MuiButton-outlined ${styles.columnOptionAdditonButton} ${
                        translationStyles1 ? styles.columnOptionAdditonButton_ar : styles.columnOptionAdditonButton_en
                      }`}
                      onClick={() => handleOption("add")}
                    >
                      {"+ "}
                      {t(`translation:Add option`)}
                    </Button>
                  ) : null}
                </Row>

                {optionAdditionType === "Create manually" ? (
                  <>
                    {data?.map((optionDetails, index) => {
                      return (
                        <div
                          key={optionDetails.label}
                          className={styles.optionDroppableDiv}
                          optionPosition={index}
                          onDragOver={allowDrop}
                          onDrop={(event) => handleDrop(event)}
                        >
                          <Row
                            key={optionDetails.label}
                            className={styles.labelValueColumnOptionAdditionRow}
                            id={"optionDetails_" + index}
                            optionPosition={index}
                            // draggable="true"
                            onDragStart={(event) => handleDrag(event)}
                          >
                            <Col
                              className={styles.labelValueColumnOptionAdditionDragIcon}
                              optionPosition={index}
                              onDragOver={allowDrop}
                              style={{ display: "none", position: "absolute !important" }}
                              onDrop={(event) => handleDrop(event)}
                            >
                              <span optionPosition={index} onDragOver={allowDrop} onDrop={(event) => handleDrop(event)}>
                                <DragAdvListview />
                              </span>
                            </Col>

                            <Col
                              id={"optionDetails_" + index}
                              optionPosition={index}
                              className={styles.labelValueColumnAdditionOptionCol}
                              onDragOver={allowDrop}
                              onDrop={(event) => handleDrop(event)}
                            >
                              <p
                                className={styles.labelValueColumnOptionAdditionType}
                                optionPosition={index}
                                onDragOver={allowDrop}
                                onDrop={(event) => handleDrop(event)}
                              >
                                {"Option " + (index + 1) + " Label"}
                                {propertiesJson?.ColumnType !== "combo" && <span style={{ color: "#D53D3D" }}> * </span>}
                              </p>

                              <input
                                aria-label={"Control Value6"}
                                key={optionDetails.label}
                                type="text"
                                defaultValue={optionDetails.label}
                                optionPosition={index}
                                className={styles.labelValueColumnOptionAdditionInput}
                                onDragOver={allowDrop}
                                onDrop={(event) => handleDrop(event)}
                                onBlur={(event) => handleOption("modify", index, "label", event.target.value)}
                              />
                            </Col>

                            <Col
                              id={"optionDetails_" + index}
                              optionPosition={index}
                              className={styles.labelValueColumnAdditionOptionCol}
                              onDragOver={allowDrop}
                              onDrop={(event) => handleDrop(event)}
                            >
                              <p
                                className={styles.labelValueColumnOptionAdditionType}
                                optionPosition={index}
                                onDragOver={allowDrop}
                                onDrop={(event) => handleDrop(event)}
                              >
                                {t(`translation:Option Value`)}
                                {propertiesJson?.ColumnType !== "combo" && <span style={{ color: "#D53D3D" }}> * </span>}
                              </p>

                              <input
                                aria-label={"Control Value7"}
                                key={optionDetails.value}
                                type="text"
                                defaultValue={optionDetails.value}
                                optionPosition={index}
                                className={styles.labelValueColumnOptionAdditionInput}
                                onDragOver={allowDrop}
                                onDrop={(event) => handleDrop(event)}
                                onBlur={(event) => handleOption("modify", index, "value", event.target.value)}
                              />
                            </Col>

                            <Col className={styles.labelValueColumnOptionAdditionCrossButton}>
                              {props?.data?.elem_type === "table" && propertiesJson?.options?.length === 1 && propertiesJson?.ColumnType !== "combo" ? null : (
                                <span onClick={() => handleOption("delete", index)}>
                                  <CrossIcon onClick={() => handleOption("delete", index)} />
                                </span>
                              )}
                            </Col>
                          </Row>
                        </div>
                      );
                    })}
                  </>
                ) : (
                  <>
                    <div>
                      <div className={styles.leftLabelForTextBox + " " + styles.columnPropertyName}>
                        <p>{t("translation:Query")} </p>
                      </div>

                      <div>
                        <textarea
                          aria-label={"Query"}
                          className={[
                            styles.multiSelectLayoutStyletextAreaQuery,
                            errorMessageId === columnsStyle.columnIndex + key ? styles.inputBoxErrorStyle : null
                          ].join(" ")}
                          rows="2"
                          cols="25"
                          defaultValue={decrypt_msg[ColumnPropertiesJson["dropdown"]["Query"]["field"]]}
                          id={columnsStyle.columnIndex + key}
                          key={props.data.id+propertiesJson.ColumnName+key}
                          onBlur={async (event) =>
                            handleProperty(ColumnPropertiesJson["dropdown"]["Query"]["field"], await encrypt(event.target.value || ""), event)
                          }
                        ></textarea>
                      </div>
                    </div>

                    {errorMessageId === columnsStyle.columnIndex + key ? (
                      <ErrorMessageComponent errorMessage="non-permissible value" />
                    ) : null}
                  </>
                )}
              </>
            ) : (
              <>
                <div>
                  <div style={{ width: "30%", display: "flex" }}>
                    <p
                      style={
                        translationStyles1
                          ? { color: "black", marginLeft: "10px" }
                          : { color: "black", marginRight: "10px" }
                      }
                    >
                      {t("translation:Enable Caching")}
                    </p>
                    <ToggleBtn
                      toggleState={propertiesJson["Cache"] ? propertiesJson["Cache"] : null}
                      field={"Cache"}
                      handleToggle={handleToggle}
                    />
                  </div>
                  <div className={styles.leftLabelForTextBox + " " + styles.columnPropertyName}>
                    <p style={{ color: "black" }}>{t("translation:Query")}</p>
                  </div>

                  <div>
                    <textarea
                      aria-label={columnsStyle.columnIndex + key}
                      className={[
                        styles.multiSelectLayoutStyletextAreaQuery,
                        errorMessageId === columnsStyle.columnIndex + key ? styles.inputBoxErrorStyle : null
                      ].join(" ")}
                      rows="2"
                      cols="25"
                      defaultValue={decrypt_msg[ColumnPropertiesJson["listbox"]["Query"]["field"]]}
                      id={columnsStyle.columnIndex + key}
                      key={props.data.id+propertiesJson.ColumnName+key}
                      onBlur={async (event) =>
                        handleProperty(ColumnPropertiesJson["listbox"]["Query"]["field"], await encrypt(event.target.value || ""), event)
                      }
                    ></textarea>
                  </div>
                </div>
                {errorMessageId === columnsStyle.columnIndex + key ? (
                  <ErrorMessageComponent errorMessage="non-permissible value" />
                ) : null}
              </>
            )}
          </>
        );
    }
  }

  let CollapsibleItems = [];
  let BasicDetailsLeftSide = [];
  let BasicDetailsRightSide = [];
  let BasicDetailsBottom = [];
  let inputValidationsLeft = [];
  let inputValidationsRight = [];
  let appearanceLeft = [];
  let appearanceRight = [];

  if (selectedColumn && selectedColumn !== null) {
    const isAdvanceListview = props?.data?.elem_type === "advancelistView" || props?.data?.elem_type === "advancelistview";
    const isListView = props?.data?.elem_type === "listview";
    const isTable = props?.data?.elem_type === "table";

    Object.keys(ColumnPropertiesJson).forEach((key, index) => {
      if (key === "Basic") {
        Object.keys(ColumnPropertiesJson[key]).forEach((property) => {
          if (ControlsMap[property].type) {
            if (ControlsMap[property].alignment === "left") {
              BasicDetailsLeftSide.push(
                prepareHtmlTag(
                  property,
                  ControlsMap[property].type,
                  ControlsMap[property]["styleKey"],
                  ControlsMap[property].alignment
                )
              );
            } else if (ControlsMap[property].alignment === "right") {
              BasicDetailsRightSide.push(
                prepareHtmlTag(
                  property,
                  ControlsMap[property].type,
                  ControlsMap[property]["styleKey"],
                  ControlsMap[property].alignment
                )
              );
            } else {
              BasicDetailsBottom.push(
                prepareHtmlTag(
                  property,
                  ControlsMap[property].type,
                  ControlsMap[property]["styleKey"],
                  ControlsMap[property].alignment
                )
              );
            }
          }
        });
        if (propertiesJson?.["ColumnType"]) {
          const isAdvanceListviewAndOptions =
            isAdvanceListview && ColumnPropertiesJson?.[propertiesJson?.["ColumnType"]]?.["heading"] === "Options";
          const columnType = propertiesJson["ColumnType"];
          if (columnType === "link" || columnType === "label") {
            const ar = [];

            Object.keys(ColumnPropertiesJson[columnType]).forEach((key) => {
                const shouldShowMethodNameForTableLabel =
                  isTable && columnType === "label" && key === "MethodName1";

                if (shouldShowMethodNameForTableLabel || (!(isAdvanceListview && columnType === "label") && key !== "heading")) {
                ar.push(
                  prepareHtmlTag(key, ControlsMap[key].type, ControlsMap[key]["styleKey"], ControlsMap[key].alignment)
                );
              }
            });

            CollapsibleItems.push(
              isAdvanceListview && columnType === "label" ? null : (
                <CollapsibleComponent
                  id={`${columnType}-grid`}
                  heading={ColumnPropertiesJson[columnType]["heading"]}
                  fullBody={ar}
                />
              )
            );
          } else if (propertiesJson["ColumnType"] === "radio" && isTable) {
            const ar = [];

            ar.push(
              isAdvanceListview
                ? null
                : optionLabelValueAdditionComponent(
                    ColumnPropertiesJson["radio"]["optionAddition"],
                    propertiesJson["options"]
                  )
            );
            CollapsibleItems.push(
              isAdvanceListviewAndOptions ? null : (
                <CollapsibleComponent
                  id="datepicker"
                  heading={ColumnPropertiesJson[propertiesJson["ColumnType"]]["heading"]}
                  fullBody={ar}
                />
              )
            );
          } else if (propertiesJson["ColumnType"] === "listbox") {
            const ar = [];
            ar.push(
              isAdvanceListview
                ? null
                : optionLabelValueAdditionComponent(
                    ColumnPropertiesJson["dropdown"]["optionAddition"],
                    propertiesJson["options"]
                  )
            );
            CollapsibleItems.push(
              isAdvanceListviewAndOptions ? null : (
                <CollapsibleComponent
                  id="dropdown"
                  heading={ColumnPropertiesJson[propertiesJson["ColumnType"]]["heading"]}
                  fullBody={ar}
                />
              )
            );
          } else if (propertiesJson["ColumnType"] === "picklist" && isTable) {
            const ar = [];
            ar.push(
              isAdvanceListview
                ? null
                : optionLabelValueAdditionComponent(
                    ColumnPropertiesJson["picklist"]["optionAddition"],
                    propertiesJson["options"]
                  )
            );
            CollapsibleItems.push(
              isAdvanceListviewAndOptions ? null : (
                <CollapsibleComponent
                  id="dropdown"
                  heading={ColumnPropertiesJson[propertiesJson["ColumnType"]]["heading"]}
                  fullBody={ar}
                />
              )
            );
          } else if (propertiesJson["ColumnType"] === "combo" && isTable) {
            const ar = [];
            ar.push(
              isAdvanceListview
                ? null
                : optionLabelValueAdditionComponent(
                    ColumnPropertiesJson["combo"]["optionAddition"],
                    propertiesJson["options"]
                  )
            );
            CollapsibleItems.push(
              isAdvanceListviewAndOptions ? null : (
                <CollapsibleComponent
                  id="combo"
                  heading={ColumnPropertiesJson[propertiesJson["ColumnType"]]["heading"]}
                  fullBody={ar}
                />
              )
            );
          } else if (propertiesJson["ColumnType"] === "toggle" && isTable) {
            const ar = [];
            Object.keys(ColumnPropertiesJson["toggle"]) &&
              Object.keys(ColumnPropertiesJson["toggle"]).forEach((key) => {
                if (!(isAdvanceListview && key === "ToggleStates")) {
                  ar.push(optionLabelValueAdditionComponent(key, propertiesJson));
                }
              });
            CollapsibleItems.push(
              isAdvanceListview ? null : (
                <CollapsibleComponent
                  id="toggle"
                  heading={ColumnPropertiesJson[propertiesJson["ColumnType"]]["heading"]}
                  fullBody={ar}
                />
              )
            );
          }
        }
      } else if (key === "InputValidations" && isTable) {
        if ((propertiesJson["ColumnType"] === "textbox" || propertiesJson["ColumnType"] === "textarea") && propertiesJson.controlName !== "richtexteditor") {
          Object.keys(ColumnPropertiesJson[key]).forEach((property) => {
            if (ControlsMap[property] && ControlsMap[property].alignment === "left") {
              inputValidationsLeft.push(
                prepareHtmlTag(
                  property,
                  ControlsMap[property].type,
                  ControlsMap[property]["styleKey"],
                  ControlsMap[property].alignment
                )
              );
            } else if (ControlsMap[property] && ControlsMap[property].alignment === "right") {
              inputValidationsRight.push(
                prepareHtmlTag(
                  property,
                  ControlsMap[property].type,
                  ControlsMap[property]["styleKey"],
                  ControlsMap[property].alignment
                )
              );
            }
          });

          CollapsibleItems.push(
            <CollapsibleComponent
              id={index + ""}
              heading="Input Validations"
              leftBody={inputValidationsLeft}
              rightBody={inputValidationsRight}
            />
          );
        }
      } else if (key === "Appearance") {
        if (propertiesJson["ColumnType"] !== "button" && propertiesJson.controlName !== "richtexteditor") {
          Object.keys(ColumnPropertiesJson[key]).forEach((property) => {
            if (ControlsMap[property] && ControlsMap[property].alignment === "left") {
              appearanceLeft.push(
                prepareHtmlTag(
                  property,
                  ControlsMap[property].type,
                  ControlsMap[property]["styleKey"],
                  ControlsMap[property].alignment
                )
              );
            } else if (ControlsMap[property] && ControlsMap[property].alignment === "right") {
              appearanceRight.push(
                prepareHtmlTag(
                  property,
                  ControlsMap[property].type,
                  ControlsMap[property]["styleKey"],
                  ControlsMap[property].alignment
                )
              );
            }
          });

          CollapsibleItems.push(
            <CollapsibleComponent id={index + ""} heading={key} leftBody={appearanceLeft} rightBody={appearanceRight} />
          );
        }
      } else if (key === "ButtonAppearance") {
        if (propertiesJson["ColumnType"] === "button") {
          Object.keys(ColumnPropertiesJson[key]).forEach((property) => {
            if (ControlsMap[property] && ControlsMap[property].alignment === "left") {
              inputValidationsLeft.push(
                prepareHtmlTag(
                  property,
                  ControlsMap[property].type,
                  ControlsMap[property]["styleKey"],
                  ControlsMap[property].alignment,
                  { isButtonAppearance: true }
                )
              );
            } else if (ControlsMap[property] && ControlsMap[property].alignment === "right") {
              inputValidationsRight.push(
                prepareHtmlTag(
                  property,
                  ControlsMap[property].type,
                  ControlsMap[property]["styleKey"],
                  ControlsMap[property].alignment,
                  { isButtonAppearance: true }
                )
              );
            }
          });

          CollapsibleItems.push(
            <CollapsibleComponent
              id={index + ""}
              heading="Button Appearance"
              leftBody={inputValidationsLeft}
              rightBody={inputValidationsRight}
            />
          );
        }
      } else if (key === "datepick") {
        if (propertiesJson["ColumnType"] === "datepick" || propertiesJson["ColumnType"] === "datetimepick") {
          Object.keys(ColumnPropertiesJson[key].left).forEach((property) => {
            if (ControlsMap[property] && ControlsMap[property].alignment === "left") {
              inputValidationsLeft.push(
                prepareHtmlTag(
                  property,
                  ControlsMap[property].type,
                  ControlsMap[property]["styleKey"],
                  ControlsMap[property].alignment
                )
              );
            }
          });
          Object.keys(ColumnPropertiesJson[key].right).forEach((property) => {
            if (ControlsMap[property] && ControlsMap[property].alignment === "right") {
              inputValidationsRight.push(
                prepareHtmlTag(
                  property,
                  ControlsMap[property].type,
                  ControlsMap[property]["styleKey"],
                  ControlsMap[property].alignment
                )
              );
            }
          });

          CollapsibleItems.push(
             // isAdvanceListview || isListView  ? null :
            (
              <CollapsibleComponent
                id={index + ""}
                heading="Date Configurations"
                leftBody={inputValidationsLeft}
                rightBody={inputValidationsRight}
              />
            )
          );
        }
      }
    });
  }

  function handleIcon(iconName, iconFile) {
    setPropertiesJson((prev) => {
      return { ...prev, TableButtonImageFile: iconFile, TableButtonImageName: iconName };
    });

    setErrorMessageId(false);
  }

  function handleToggle(e, field) {
    const value = e.target.value;
    setPropertiesJson((prev) => {
      return { ...prev, [field]: value };
    });
    setColumnPropertiesChanged(true);
  }

  function validateDate(event, key, dateValue) {
    setPropertiesJson((prev) => {
      return { ...prev, [key]: dateValue, ["isModify"]: "true" };
    });
  }

  function getToday(){
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    var currDate = yyyy + "-" + mm + "-" + dd;
    return currDate
  }

  function setDate(event, key, propertyValue) {
    var todayDate = getToday();

    if (key === "MinDate") {
      setMinDate(propertyValue);
    } else if (key === "MaxDate") {
      setMaxDate(propertyValue);
    }

    if (key === "MinDateAsCurrentTable" && propertyValue === "true") {
      setMinDate(todayDate)
      setPropertiesJson((prev) => {
        return { ...prev, ["MinDate"]: todayDate, ["isModify"]: "true" };
      });
    } else if (key === "MinDateAsCurrentTable" && propertyValue === "false") {
      setMinDate("")
      setPropertiesJson((prev) => {
        const newProperties = { ...prev };
        delete newProperties.MinDate;
        newProperties["isModify"] = "true";
        return newProperties;
      });
    }

    if (key === "MaxDateAsCurrentTable" && propertyValue === "true"){
      setMaxDate(todayDate)
      setPropertiesJson((prev) => {
        return { ...prev, ["MaxDate"]: todayDate, ["isModify"]: "true" };
      });
    } else if (key === "MaxDateAsCurrentTable" && propertyValue === "false"){
      setMaxDate("")
      setPropertiesJson((prev) => {
        const newProperties = { ...prev };
        delete newProperties.MaxDate;
        newProperties["isModify"] = "true";
        return newProperties;
      });
    }

    setPropertiesJson((prev) => {
      return { ...prev, [key]: propertyValue, ["isModify"]: "true" };
    });
    setColumnPropertiesChanged(true);
  }

  function prepareHtmlTag(key, type, styleKey, alignment, extraInfo = {}) {
    switch (type.toLowerCase()) {
      case "date":
        return (<>{props.data.elem_type === "table" && (
          <div className={styles.parentDiv} key={key} >
            <span className={styles.leftLabel}>{t(`translation:${ControlsMap[key].label}`)}</span>
            <div
              style={{ position: "relative", width: "168px", height: "24px", float: "right", color: "black"}}
            >
              {key === "MinDate" &&
              propertiesJson?.MinDateAsCurrentTable === "true" ? (
                  <DatePickers
                      key={key}
                      onChange={(event) =>
                          setDate(event, key, event.target.value)
                      }
                      id={key}
                      dateClearBoolean={minDateClear}
                      dateClearHandler={setMinDateClear}
                      disableDate={true}
                      timeFormat={false}
                      value={minDate}
                      className={styles.RightLabelDateTable}
                      align="top"
                      disableAfter={propertiesJson?.MaxDate || maxDate}
                  />
              ) : key === "MaxDate" &&
              propertiesJson?.MaxDateAsCurrentTable === "true" ? (
                      <>
                        <DatePickers
                            key={key}
                            id={key}
                            dateClearBoolean={maxDateClear}
                            dateClearHandler={setMaxDateClear}
                            onChange={(event) =>
                                setDate(event, key, event.target.value)
                            }
                            disableDate={true}

                            timeFormat={false}
                            value={maxDate}
                            className={styles.RightLabelDateTable}
                            align="top"
                            disableBefore={propertiesJson?.MinDate || minDate}
                        />
                      </>
                  ) :
                key === "MinDate" ? (
                <DatePickers
                  key={key}
                  onChange={(event) => setDate(event, key, event.target.value)}
                  id={key}
                  dateClearBoolean={minDateClear}
                  dateClearHandler={setMinDateClear}
                  timeFormat={false}
                  value={propertiesJson[key]}
                  className={styles.RightLabelDateTable}
                  align="top"
                  disableAfter={propertiesJson?.MaxDate || maxDate}
                />
              ) : key === "MaxDate" ? (
                <>
                  <DatePickers
                    key={key}
                    id={key}
                    dateClearBoolean={maxDateClear}
                    dateClearHandler={setMaxDateClear}
                    onChange={(event) => setDate(event, key, event.target.value)}
                    timeFormat={false}
                    value={propertiesJson[key]}
                    className={styles.RightLabelDateTable}
                    align="top"
                    disableBefore={propertiesJson?.MinDate || minDate}
                  />
                </>
              ) : null}
            </div>
          </div>)}</>
        );

      case "checkboxcurrentdate":
        return (
            <div
                className={styles.parentDiv + " " + styles.datepickerCheckboxDiv}
                style={translationStyles1?{display:"flex"}:null}
            >
              {propertiesJson[key] === "true" ? (
                  <input
                      aria-label={"Control Value5"}
                      type="checkbox"
                      key={key}
                      name={t(`translation:${ControlsMap[key].label}`)}
                      onChange={(event) => setDate(event, key, "false")}
                      checked="checked"
                      className={styles.leftCheckboxStyling}
                  />
              ) : (
                  <input
                      aria-label={"Control Value6"}
                      type="checkbox"
                      key={key}
                      name={t(`translation:${ControlsMap[key].label}`)}
                      onChange={(event) => setDate(event, key, "true")}
                      className={styles.leftCheckboxStyling}
                  />
              )}
              <label className={styles.rightCheckboxStyling}>
                {t(`translation:${ControlsMap[key].label}`)}
              </label>
            </div>
        );

      case "combodateformat":
        return (
          (propertiesJson["ColumnType"] === "datepick" || propertiesJson["ColumnType"] === "datetimepick") && (
            <div className={styles.colParentDiv2} style={{ marginBottom: "15px" }}>
              <span className={styles.columnPropertyName2} style={{ marginLeft: "0px" }}>
                {t(`translation:${ControlsMap[key].label}`)}
              </span>
              <div className={styles.RightLabelSelectDiv2} style={{ display: "flex", marginRight: "13px" }}>
                <select
                  className={`${styles.colPropertyValueInput5} ${styles.inputBoxWidth}`}
                  style={{ width: "100px" }}
                  name={key}
                  key={`${key}${type}`}
                  onChange={(ev) => handleComboDate(key, ev.target.value)}
                >
                  {ControlsMap[key].children.map((optionTagData, optionCount) => {
                    if (ControlsMap[key].children[optionCount].Value) {
                      if (propertiesJson["ColumnType"] === "datepick") {
                        if (ControlsMap[key].children[optionCount].Title === "DD/MM/YYYY") {
                        }
                        return (
                          <>
                            {ControlsMap[key].children[optionCount].Title === "DD/MM/YYYY" ||
                            ControlsMap[key].children[optionCount].Title === "DD/MMM/YYYY" ||
                            ControlsMap[key].children[optionCount].Title === "MM/DD/YYYY" ||
                            ControlsMap[key].children[optionCount].Title === "YYYY/MM/DD" ? (
                              ControlsMap[key].children[optionCount].Value === propertiesJson[key] ? (
                                <option value={ControlsMap[key].children[optionCount].Value} selected>
                                  {t(`translation:${ControlsMap[key].children[optionCount].Title}`)}
                                </option>
                              ) : (
                                <option value={ControlsMap[key].children[optionCount].Value}>
                                  {t(`translation:${ControlsMap[key].children[optionCount].Title}`)}
                                </option>
                              )
                            ) : null}
                          </>
                        );
                      }
                      if (propertiesJson["ColumnType"] === "datetimepick") {
                        if (ControlsMap[key].children[optionCount].Title === "DD/MM/YYYY, HH:MM") {
                        }
                        return (
                          <>
                            {ControlsMap[key].children[optionCount].Title === "DD/MM/YYYY, HH:MM" ||
                            ControlsMap[key].children[optionCount].Title === "MM/DD/YYYY, HH:MM" ||
                            ControlsMap[key].children[optionCount].Title === "YYYY/MM/DD, HH:MM" ||
                            ControlsMap[key].children[optionCount].Title === "DD/MMM/YYYY, HH:MM" ? (
                              ControlsMap[key].children[optionCount].Value === propertiesJson[key] ? (
                                <option value={ControlsMap[key].children[optionCount].Value} selected>
                                  {ControlsMap[key].children[optionCount].Title}
                                </option>
                              ) : (
                                <option value={ControlsMap[key].children[optionCount].Value}>
                                  {ControlsMap[key].children[optionCount].Title}
                                </option>
                              )
                            ) : null}
                          </>
                        );
                      }
                    } else {
                      return null;
                    }
                  })}
                </select>
              </div>
            </div>
          )
        );

      case "uploadbtn":
        return (
            <div className={alignment === "left" ? styles.colParentDiv : styles.colParentDiv2}>
              <div className="uploadbtn">
                <span className={styles.columnPropertyName2} style={{ marginLeft: "0px" }}>
                  {t(`translation:${ControlsMap[key].label}`)}
                </span>

                <ImageUploadBtn
                  containerId={props.containerId}
                  handleImageUpload={handleIcon}
                  iconName={propertiesJson?.TableButtonImageName}
                  placeholder={t(`translation:Browse icon from system`)}
                />
              </div>
            </div>
        );

      case "combo":
        return (propertiesJson.ColumnType === "radio" && key === "RadioAlignment" && props?.data?.elem_type === "table") || key !== "RadioAlignment" ? (
          <div className={alignment === "left" ? styles.colParentDiv : styles.colParentDiv2}>
            <span
              className={alignment === "left" ? styles.columnPropertyName : styles.columnPropertyName2}
              style={alignment != "left" && translationStyles1 ? { marginLeft: "unset", marginRight: "24px" } : null}
            >
              {t(`translation:${ControlsMap[key].label}`)}
              {key === "ColumnType" ? <span style={{ color: "#D53D3D" }}> * </span> : null}
            </span>

            {key === "ColumnMasking" ? (
              <select
                className={`${styles.colPropertyValueInput5} ${styles.inputBoxWidth}`}
                name={key}
                id={key}
                onChange={() => handleCombo(key)}
                disabled={isPropertyAllowed(key)}
              >
                {maskingKeys !== undefined &&
                  maskingKeys.length > 0 &&
                  maskingKeys.map((mapJson, mapCount) => {
                    return (
                      <>
                        {propertiesJson[key] === mapJson.Value ? (
                          <option value={mapJson.Value} selected>
                            {mapJson.Title}
                          </option>
                        ) : (
                          <option value={mapJson.Value}>{mapJson.Title}</option>
                        )}
                      </>
                    );
                  })}
              </select>
            ) : key === "AssociatedField" ? (
              <>
                <select
                  aria-label="Associated Field"
                  className={`${styles.colPropertyValueInput5} ${styles.inputBoxWidth}`}
                  name={key}
                  id={key}
                  onChange={() => handleCombo(key)}
                  disabled={isPropertyAllowed(key)}
                >
                  {associatedField !== undefined &&
                    associatedField.length > 0 &&
                    associatedField.map((associatedField, mapCount) => {
                      return (
                        <>
                          {propertiesJson["complexFieldName"] === associatedField ? (
                            <option value={associatedField} selected>
                              {associatedField === "Select" ? t(`translation:${associatedField}`) : associatedField}
                            </option>
                          ) : !complexField.includes(associatedField) || (sessionOption === associatedField) ? (
                            <option value={associatedField}>
                              {associatedField === "Select" ? t(`translation:${associatedField}`) : associatedField}
                            </option>
                          ) : (
                            ""
                          )}
                        </>
                      );
                    })}
                </select>
              </>
            ) : (
              <>
                <div style={{ display: "flex", flexDirection: "column", width: "58%" }}>
                  <select
                    style={{
                      height: "24px !important",
                      ...(extraInfo.isButtonAppearance ? { width: "calc(100% - 12px)" } : {})
                    }}
                    className={
                      alignment === "left"
                        ? styleKey === "columnType" && mandatoryErrors.columnType === true
                          ? `${styles.colPropertyValueInput} ${styles.inputSelectWidth} ${styles.colPropertyValueInputMandatory}`
                          : `${styles.colPropertyValueInput} ${styles.inputSelectWidth}`
                        : styles.colPropertyValueInput4
                    }
                    name={key === "GridDateSeperator" ? "DateSeperator" : key}
                    id={key}
                    onChange={() => handleCombo(key)}
                  >
                    {ControlsMap[key].children.map((optionTagData, optionCount) => {
                      if (
                        propertiesJson && propertiesJson[key] === "textarea"
                          ? propertiesJson.isRichTextEditor
                            ? ControlsMap[key].children[optionCount].Title === "Richtext Editor"
                            : ControlsMap[key].children[optionCount].Title === "Textarea"
                          : ControlsMap[key].children[optionCount].Value === propertiesJson[key]
                      ) {
                        return (
                          <option
                            key={ControlsMap[key].children[optionCount].Value}
                            value={ControlsMap[key].children[optionCount].Value}
                            selected
                          >
                            {t(`translation:${ControlsMap[key].children[optionCount].Title}`)}
                          </option>
                        );
                      } else {
                        if (
                          (props?.data?.elem_type !== "advancelistView" &&
                            props?.data?.elem_type !== "advancelistview" &&
                            ControlsMap[key].children[optionCount].Value === "listbox") ||
                          (ControlsMap[key].children[optionCount].Value === "link" &&
                            props?.data?.elem_type === "table") || 
                        (ControlsMap[key].children[optionCount].Value === "password" && props?.data?.elem_type !== "table")
                        ) {
                          return null;
                        } else if (
                          (props?.data?.elem_type.toLowerCase() === "table" ||
                            props?.data?.elem_type.toLowerCase() === "advancelistview") &&
                          ControlsMap[key].children[optionCount].Title === "Richtext Editor"
                        ) {
                          // return (
                          //   <option
                          //   key={ControlsMap[key].children[optionCount].Value}
                          //   value={ControlsMap[key].children[optionCount].Value}
                          //   >
                          //     {/* {props?.data?.elem_type !=="table" && ControlsMap[key].children[optionCount].Value !== "richtextarea"&& */}
                          //      {t(`translation:${ControlsMap[key].children[optionCount].Title}`)}
                          //   </option>
                          // );
                          return null;
                        } else {
                          return (
                            <option
                              key={ControlsMap[key].children[optionCount].Value}
                              value={ControlsMap[key].children[optionCount].Value}
                            >
                            {t(`translation:${ControlsMap[key].children[optionCount].Title}`)}
                            </option>
                          );
                        }
                      }
                    })}
                  </select>
                  {styleKey === "columnType" && mandatoryErrors.columnType === true ? (
                    <span style={{ color: "#D53D3D" }}>{t(`translation:This is required field`)}</span>
                  ) : null}
                </div>
              </>
            )}
          </div>
        ) : null;

      case "textareaforquery" :
        return(
          (propertiesJson?.ColumnType === "combo" || (propertiesJson?.ColumnType === "listbox")) && (
            <>
          <div key={props.data.id+propertiesJson.ColumnName+key} className={key === "GridMasterQuery" ? styles.colParentDiv2 : ""}> 
          <div key={props.data.id+propertiesJson.ColumnName+key} className={styles.leftLabelForTextBox + " " + styles.columnPropertyName} style={key === "GridMasterQuery" ? { marginLeft: "24px" } : {}}>
            <p>{t(`translation:${ControlsMap[key].label}`)} </p>
          </div>                        
         <div key={props.data.id+propertiesJson.ColumnName+key} style={key === "GridMasterQuery" ? { width: "169px", height: "fit-content" } : {}}>
           <textarea
             aria-label={selectedColumn.style[key]}
             className={[styles.multiSelectLayoutStyletextAreaQuery,errorMessageId === (props.data.id+key) ? styles.inputBoxErrorStyle  : null].join(" ")}
             rows="3" cols="40" 
            //  defaultValue={decrypt_msg[key]} 
            //  value={decrypt_msg[key]}
             value={decrypt_msg[key]}
             onChange={(e) => {setDecrypt_msg(prev => ({...prev,[key]: e.target.value})); }}
             id={props.data.id+key}
             key={props.data.id+propertiesJson.ColumnName+key}
             onKeyDown={(event)=>validateRegex(ControlsMap[key].styleKey, event.target.value,event,props.data.id+key)}
             onBlur={async (event)=>handleProperty(ControlsMap[key].styleKey, await encrypt(event.target.value || ""), event)}
           >
           </textarea>
         </div>
          </div>
       {errorMessageId === (props.data.id+key) ? <ErrorMessageComponent errorMessage="non-permissible value"/> : null}
       </> 
)
        );

      case "smallcombo":
        return (
          <div className={styles.colParentDiv5}>
            <span
              className={alignment === "left" ? styles.columnPropertyName : styles.columnPropertyName2}
              style={alignment != "left" && translationStyles1 ? { marginLeft: "unset", marginRight: "24px" } : null}
            >
              {t(`translation:${ControlsMap[key].label}`)}
            </span>
            <select
              className={`${styles.colPropertyValueInput5} ${styles.inputBoxWidth}`}
              name={key}
              id={key}
              onChange={() => handleCombo(key)}
              disabled={isPropertyAllowed(key)}
            >
              {ControlsMap[key].children.map((optionTagData, optionCount) => {
                if (propertiesJson && ControlsMap[key].children[optionCount].Value === propertiesJson[key]) {
                  return (
                    <option
                      key={ControlsMap[key].children[optionCount].Value}
                      value={ControlsMap[key].children[optionCount].Value}
                      selected
                    >
                      {t(`translation:${ControlsMap[key].children[optionCount].Title}`)}
                    </option>
                  );
                } else {
                  return (
                    <option
                      key={ControlsMap[key].children[optionCount].Value}
                      value={ControlsMap[key].children[optionCount].Value}
                    >
                      {t(`translation:${ControlsMap[key].children[optionCount].Title}`)}
                    </option>
                  );
                }
              })}
            </select>
          </div>
        );

      case "text":
        return (
          <>
            <div className={alignment === "left" ? styles.colParentDiv : styles.colParentDiv2}>
              <span
                className={alignment === "left" ? styles.columnPropertyName : styles.columnPropertyName2}
                style={alignment != "left" && translationStyles1 ? { marginLeft: "unset", marginRight: "24px" } : null}
              >
                {t(`translation:${ControlsMap[key].label}`)}
                {key === "ColumnName" ? <span style={{ color: "#D53D3D" }}> * </span> : null}
              </span>

              <div style={{ display: "flex", flexDirection: "column", position: "relative" }}>
                <input
                  aria-label={"Control Value8"}
                  type="text"
                  defaultValue={propertiesJson?.[styleKey] ? propertiesJson[styleKey] : null}
                  style={{
                    borderColor: `${
                      styleKey === "ColumnName" && mandatoryErrors.columnName === true ? "#D53D3D" : "#d7d7d7"
                    }`
                  }}
                  key={props.data.id + styleKey}
                  className={[
                    alignment === "left" ? styles.colPropertyValueInput : styles.colPropertyValueInput4,
                    errorMessageId === props.data.id + styleKey ? styles.inputBoxErrorStyle : null
                  ].join(" ")}
                  onKeyUp={(event) => handleProperty(styleKey, event.target.value, event, props.data.id + styleKey)}
                  onBlur={(event) => addColumnName(styleKey, event.target.value)}
                />

                {styleKey === "ColumnName" && mandatoryErrors.columnName === true ? (
                  <span style={{ color: "#D53D3D", position: "absolute", bottom: "-17px" }}>
                    {t(`translation:This is required field`)}
                  </span>
                ) : null}
              </div>
              {errorMessageId === props.data.id + styleKey ? (
                <ErrorMessageComponent errorMessage="non-permissible value" />
              ) : null}
            </div>
          </>
        );

      case "checkbox":
        return (
          <div className={styles.checkboxComponent}>
            {
              ControlsMap[key].styleKey === "ShowToolTipAsInfoIcon"?
              <>
               <input
              aria-label={"Control Value9"}
              type="checkbox"
              className={`${styles.removeWidthInCheckBox} ${matches ? "" : styles.checkBoxHeightAddColumns}`}
              // checked={propertiesJson?.[styleKey]?.toString() === "true"}
              checked={propertiesJson?.[styleKey]?.toString() === "true"}
              onChange={() =>
                handleProperty(key, propertiesJson[key] === "true" ? "false" : "true", undefined, undefined, true)
              }
              disabled={ControlsMap[key].styleKey === "ShowToolTipAsInfoIcon" && propertiesJson["ColumnTooltip"]?.length>0 ?false:true}
              id={ControlsMap[key].label}
            />
            <label
              htmlFor={ControlsMap[key].label}
              className={styles.checkBoxSpan}
              style={
                isPropertyAllowed(key) || (key === "EnableSearch" && props?.data?.isAdvanceListview)
                  ? { color: "#d1d1d1" }
                  : {}
              }
            >
              {t(`translation:${ControlsMap[key].label}`)}
            </label>
            </>:
            <>
            <input
              aria-label={"Control Value9"}
              type="checkbox"
              className={`${styles.removeWidthInCheckBox} ${matches ? "" : styles.checkBoxHeightAddColumns}`}
              // checked={propertiesJson?.[styleKey]?.toString() === "true"}
              checked={propertiesJson?.[styleKey]?.toString() === "true"}
              onChange={() =>
                handleProperty(key, propertiesJson[key] === "true" ? "false" : "true", undefined, undefined, true)
              }
              disabled={isPropertyAllowed(key) || (key === "EnableSearch" && props?.data?.isAdvanceListview) || props.data.isTable}
              id={ControlsMap[key].label}
            />
            <label
              htmlFor={ControlsMap[key].label}
              className={styles.checkBoxSpan}
              style={
                isPropertyAllowed(key) || (key === "EnableSearch" && props?.data?.isAdvanceListview)
                  ? { color: "#d1d1d1" }
                  : {}
              }
            >
              {t(`translation:${ControlsMap[key].label}`)}
            </label>
            </>
    }
          </div>
        );

      case "smalltext":
        return (propertiesJson.ColumnType !== "textarea" && styleKey === "TableTextAreaHeight") || (props?.data?.elem_type !== "table" && styleKey === "TableTextAreaHeight") ? null : !(
            propertiesJson.complexFieldType === "Integer" ||
            propertiesJson.complexFieldType === "Long" ||
            propertiesJson.complexFieldType === "Float"
          ) &&
          (styleKey === "MinValue" || styleKey === "MaxValue") ? null : (
          <div className={alignment === "left" ? styles.colParentDiv : styles.colParentDiv5}>
            <span
              className={alignment === "left" ? styles.columnPropertyName : styles.columnPropertyName2}
              style={alignment != "left" && translationStyles1 ? { marginLeft: "unset", marginRight: "24px" } : null}
            >
              {t(`translation:${ControlsMap[key].label}`)}
            </span>
            <input
              aria-label={"Control Value10"}
              type="text"
              defaultValue={propertiesJson[styleKey] ? propertiesJson[styleKey] : null}
              className={[
                alignment === "left" ? styles.colPropertyValueInput : styles.colPropertyValueInput5,
                errorMessageId === props.data.id + styleKey ? styles.inputBoxErrorStyle : null
              ].join(" ")}
              onKeyDown={(event) =>
                validateRegex(
                  styleKey,
                  event.target.value,
                  event,
                  props.data.id + styleKey
                )
              }
              onBlur={(event) => handleProperty(styleKey, event.target.value, undefined, props.data.id + styleKey)}
              disabled={isPropertyAllowed(key)}
            />
            {errorMessageId === props.data.id + styleKey ? (
              <ErrorMessageComponent style={{ marginLeft: "24px" }} errorMessage="non-permissible value" />
            ) : null}
          </div>
        );

      case "colorpicker":
        return (
          <div className={styles.colParentDiv5}>
            <span
              className={alignment === "left" ? styles.columnPropertyName : styles.columnPropertyName2}
              style={alignment != "left" && translationStyles1 ? { marginLeft: "unset", marginRight: "24px" } : null}
            >
              {t(`translation:${ControlsMap[key].label}`)}
            </span>
            <div
              className={styles.RightLabelColorPickerDiv3}
              style={translationStyles1 ? { marginLeft: "unset" } : null}
            >
              <ColorPicker
                color={selectedColumn?.style ? selectedColumn.style[key] : null}
                handleProperty={handleProperty}
                propertyName={key}
                colorPickerInnerBoxStyle={{ top: "unset", left: "unset", right: "113px" }}
              />
            </div>
          </div>
        );

      case "toggle":
        return (
          <>
            <div className={styles.colParentDiv4}>
              <span
                className={styles.columnPropertyName}
                style={
                  isPropertyAllowed(key) || (styleKey === "SortingType" && props?.data?.isAdvanceListview)
                    ? { color: "#d1d1d1" }
                    : {}
                }
              >
                {t(`translation:${ControlsMap[key].label}`)}
              </span>
              <div
                className={styles.colPropertyToggle}
                style={{
                  ...(styleKey === "SortingType" ? { width: "169px" } : {}),
                  ...((styleKey === "SortingType" && props?.data?.isAdvanceListview) || isPropertyAllowed(key)
                    ? { pointerEvents: "none", opacity: "0.5" }
                    : {}),
                  ...(translationStyles1 ? { marginLeft: "unset" } : {})
                }}
              >
                <ToggleBtn
                  toggleState={propertiesJson[styleKey] ? propertiesJson[styleKey] : null}
                  field={styleKey}
                  externalStyling={{
                    quickToolSlideBarStyle: { height: "fit-content" },
                    quickToolSwitchStyle: styles.marginBottomZero,
                    container: { justifyContent: "start" }
                  }}
                  handleToggle={handleToggle}
                  isSaveTemplate
                />
              </div>
            </div>
            {styleKey === "AllowSpecialChars" ? (
              propertiesJson?.[styleKey] === "y" || propertiesJson?.[styleKey] === "true" ? (
                <div>
                  <input
                    aria-label={"Control Value13"}
                    type="text"
                    defaultValue={propertiesJson[styleKey] ? propertiesJson[styleKey + "Content"] : null}
                    className={alignment === "left" ? styles.colFullWidthText : styles.colPropertyValueInput4}
                    onChange={(event) => handleProperty(styleKey + "Content", event.target.value)}
                  />
                </div>
              ) : (
                <div>
                  <input
                    aria-label={"Control Value14"}
                    type="text"
                    defaultValue={propertiesJson[styleKey] ? propertiesJson[styleKey + "Content"] : null}
                    className={alignment === "left" ? styles.colFullWidthText : styles.colPropertyValueInput4}
                    disabled
                  />
                </div>
              )
            ) : null}
          </>
        );

      case "combotext":
        return (
          <>
            <div className={styles.colParentDiv} style={{ flexDirection: "column" }}>
              <div className={styles.colParentDiv} style={{ margin: "0" }}>
                <span className={styles.columnPropertyName}>{t(`translation:${ControlsMap[key].label}`)}</span>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div>
                    <select
                      name={key + "Type"}
                      id={key + "Type"}
                      className={styles.colPropertyValueInput2}
                      style={{
                        height: "24px !important",
                        ...(translationStyles1
                          ? { marginRight: "unset", marginLeft: "4px" }
                          : { marginRight: "4px", marginLeft: "unset" })
                      }}
                      onChange={(event) => handleCombo(key + "Type", event)}
                    >
                      {ControlsMap[key].children.map((optionTagData, optionCount) => {
                        if (
                          propertiesJson &&
                          ControlsMap[key].children[optionCount].Value === propertiesJson[key + "Type"]
                        ) {
                          if (propertiesJson[key + "Type"] === "pixel") {
                            checkAvailableWidth = false;
                          }
                          return (
                            <option
                              key={ControlsMap[key].children[optionCount].Value}
                              value={ControlsMap[key].children[optionCount].Value}
                              selected
                            >
                              {t(`translation:${ControlsMap[key].children[optionCount].Title}`)}
                            </option>
                          );
                        } else {
                          return (
                            <option
                              key={ControlsMap[key].children[optionCount].Value}
                              value={ControlsMap[key].children[optionCount].Value}
                            >
                              {t(`translation:${ControlsMap[key].children[optionCount].Title}`)}
                            </option>
                          );
                        }
                      })}
                    </select>

                    <input
                      aria-label={"Control Value16"}
                      type="number"
                      inputMode="numeric" // helpful on mobile
                      defaultValue={
                        propertiesJson["ColumnWidth"]
                          ? propertiesJson["ColumnWidth"].includes("%")
                            ? propertiesJson["ColumnWidth"].replace("%", "")
                            : propertiesJson["ColumnWidth"].replace("px", "")
                          : null
                      }
                      className={[
                        styles.inputAvaialableSpace,
                        styles.colPropertyValueInput3,
                        errorMessageId === props.data.id + styleKey ? styles.inputBoxErrorStyle : null
                      ].join(" ")}
                      onInput={handleWidthInput}
                      // onKeyPress={(event) =>
                      //   handleColumnWidth(styleKey, event.target.value, event, props.data.id + key)
                      // }
                      onBlur={(event) => handleColumnWidth(styleKey, event.target.value, event, props.data.id + key)}
                    />
                  </div>
                </div>
              </div>

              {props.columnsStyle[0]?.style["ColumnWidth"].includes("%") ||
              (props?.data?.columnList?.length >= 0 &&
                props?.data?.columnList?.[0]?.style?.["ColumnWidth"]?.includes("%")) ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    ...(translationStyles1
                      ? { marginLeft: "unset", marginRight: "auto" }
                      : { marginLeft: "auto", marginRight: "unset" })
                  }}
                >
                  <span style={{ paddingTop: "5px", color: "black" }}>
                    {t(`translation:Available Space`)}
                  </span>

                  <span
                    style={{
                      paddingTop: "5px",
                      ...(translationStyles1
                        ? { marginLeft: "unset", marginRight: "10px" }
                        : { marginLeft: "10px", marginRight: "unset" }),
                      color: "black"
                    }}
                  >
                    {`${
                      props.columnsStyle[0]?.style["ColumnWidth"] === ""
                        ? returnAvailableWidth(90, availableWidth)
                        : returnAvailableWidth(100, availableWidth)
                    }%`}
                  </span>
                </div>
              ) : props.data.columnList.length === 0 && props?.selectedColumn?.style?.["ColumnWidth"]?.includes("%") ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    ...(translationStyles1
                      ? { marginLeft: "unset", marginRight: "auto" }
                      : { marginLeft: "auto", marginRight: "unset" })
                  }}
                >
                  <span style={{ color: "#888", paddingTop: "5px" }}>{t(`translation:Available Space`)}</span>

                  <span
                    style={{
                      color: "#888",
                      paddingTop: "5px",
                      ...(translationStyles1
                        ? { marginLeft: "unset", marginRight: "10px" }
                        : { marginLeft: "10px", marginRight: "unset" })
                    }}
                  >
                    {"100%"}
                  </span>
                </div>
              ) : null}

              {errorMessageId === props.data.id + styleKey ? (
                <ErrorMessageComponent errorMessage="non-permissible value" />
              ) : null}
            </div>
          </>
        );

      case "header":
        return (
          <p
            className={alignment === "left" ? styles.propertiesHeader2 : styles.propertiesHeader3}
            style={
              translationStyles1
                ? alignment === "left"
                  ? { textAlign: "right" }
                  : { textAlign: "right", marginRight: "24px" }
                : null
            }
          >
            {t(`translation:${ControlsMap[key].label}`)}
          </p>
        );

      case "icon":
        return (
          <>
            <div className={styles.buttonType}>
              <span className={styles.columnPropertyName2} style={{ marginLeft: "-24px", marginBottom: "12px" }}>
                {t(`translation:${ControlsMap[key].label}`)}
              </span>
              <Row style={{ justifyContent: "space-between" }}>
                <div
                  className={(selectedButtonType === "Primary")  ? styles.buttonLayoutStyle2 : styles.buttonLayoutStyle}
                >
                  <div
                    className={styles.StyleForButton}
                    onClick={() => selectedOptionForButtonType("Primary")}
                    style={translationStyles1 ? { direction: "ltr" } : null}
                  >
                    <PrimaryButton1 />
                  </div>
                </div>

                <div
                  className={(selectedButtonType === "Secondary") ? styles.buttonLayoutStyle2 : styles.buttonLayoutStyle}
                >
                  <div
                    className={styles.StyleForButton}
                    onClick={() => selectedOptionForButtonType("Secondary")}
                    style={translationStyles1 ? { direction: "ltr" } : null}
                  >
                    <SecondaryButton />
                  </div>
                </div>

                <div className={(selectedButtonType === "Text") ? styles.buttonLayoutStyle2 : styles.buttonLayoutStyle}>
                  <div
                    className={styles.StyleForButton}
                    onClick={() => selectedOptionForButtonType("Text")}
                    style={translationStyles1 ? { direction: "ltr" } : null}
                  >
                    <TextButton />
                  </div>
                </div>
              </Row>
            </div>
          </>
        );
    }
  }

  const classes = useStyles();

  let layout;
  function findLayoutJson(formJson, tableId) {
    if (formJson.children) {
      for (let child of formJson.children) {
        if (child.id == tableId) {
          if (child.listviewFrameLayoutJson) {
            layout = JSON.stringify(child);
          }
        } else {
          findLayoutJson(child, tableId);
        }
      }
    }
  }

  const checkMandatoryFunction = (propertyName, propertyValue) => {
    if (propertyName === "ColumnName") {
      if (!propertyValue?.trim()) {
        setMandatoryErrors((prev) => {
          return { ...prev, columnName: true };
        });
        return true;
      } else {
        setMandatoryErrors((prev) => {
          return { ...prev, columnName: false };
        });
        return false;
      }
    } else if (propertyName === "ColumnType") {
      if (propertyValue === "Select") {
        setMandatoryErrors((prev) => {
          return { ...prev, columnType: true };
        });
        return true;
      } else {
        setMandatoryErrors((prev) => {
          return { ...prev, columnType: false };
        });
        return false;
      }
    }
  };

  function getColIndex() {
    let colIndex = -1;

    for (let col in columnsStyle) {
      colIndex++;
      if (columnsStyle[col].style.ColumnName === selectedColumn.style.ColumnName) {
        return colIndex;
      }
    }
  }
  useEffect(() => {
    document.getElementById("backdropDiv")?.focus();
  }, []);
  function handleEscapeKey(e) {
    if (e.code === "Escape" && props?.showTableBackdrop === true) {
      props.setShowTableBackdrop(false);
      dispatch(updateStateInRedux({name: 'addColumnOpen',value: false}))
    }
  }

  function changeElemType(colIndex) {
    const columnListTemp = props?.data?.columnList;
    const modifiedColumnIndex = columnListTemp?.findIndex((item) => item.columnIndex === colIndex);

    if (modifiedColumnIndex !== -1) {
      const modifiedColumn = columnListTemp[modifiedColumnIndex];
      const elemType =
        modifiedColumn.style.ColumnType === "datetimepick" ? "datepick" : modifiedColumn.style.ColumnType;

      modifiedColumn.elementJson.elem_type = elemType;
      modifiedColumn.elementJson.controlName = modifiedColumn.style.controlName === "richtexteditor" ? "richtexteditor" : elemType;

      // if (modifiedColumn.style.ColumnType === "datetimepick") {
      //   modifiedColumn.style.PickerType = "2";
      //   modifiedColumn.style.DateFormat = "5";
      // } else if (modifiedColumn.style.ColumnType === "datepick") {
      //   modifiedColumn.style.DateFormat = "1";
      //   modifiedColumn.style.PickerType = "1";
      // }
    }
  }

  const checkForAnyEmptyOption = () => {
    let isNotFilled = false;
    for (let i = 0; i < propertiesJson?.options?.length; i++) {
      if (!propertiesJson?.options?.[i]?.value?.trim()) {
        isNotFilled = true;
      }
      if (!propertiesJson?.options?.[i]?.label?.trim()) {
        isNotFilled = true;
      }
    }

    if (isNotFilled) {
      showError(true);
    }
    return isNotFilled;
  }

  const preSavingValidations = (arg) => {
    if (!arg) {
      return true;
    }

    const isAdvanceListview = props?.data?.elem_type?.toLowerCase() === "advancelistview";
    const isTable = props?.data?.elem_type?.toLowerCase() === "table";

    // if (
    //   propertiesJson.ColumnType === "toggle" &&
    //   (!propertiesJson.ToggleStates || propertiesJson.ToggleStates === "Select") &&
    //   isTable
    // ) {
    //   showAlertConfirmNotifications({
    //     open: true,
    //     showConfirm: "showNotification",
    //     alertType: "error",
    //     alertContentKey: `${t("translation:Grid_Mandatory_Toggle_State")}`
    //   });
    //   return false;
    // }

    if (parseInt(propertiesJson.TableTextAreaHeight) <= 75) {
      showAlertConfirmNotifications({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentKey: `${t("translation:Textarea_Height_Validation")}`
      });
      return false;
    }

    if (propertiesJson.ColumnType === "toggle" && propertiesJson.ToggleStates === "CustomState" && isTable) {
      if (!propertiesJson.ToggleState1 || !propertiesJson.ToggleState2) {
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: `${t("translation:Grid_Mandatory_Custom_State")}`
        });
        return false;
      }
    }

    if (propertiesJson.ColumnType === "radio" && isTable) {
      if (!propertiesJson?.options?.length) {
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: `${t("translation:Grid_Mandatory_Options")}`
        });
        return false;
      }
    }

    if (
      propertiesJson.ColumnType === "radio" ||
      (propertiesJson.ColumnType === "combo" &&
        (propertiesJson.addOptionsMethod === "manually" || propertiesJson.addOptionsMethod === undefined))
    ) {
      const check = checkForAnyEmptyOption();
      if (check) {
        return false;
      }
    }

    if (propertiesJson.ColumnType === "picklist" && !propertiesJson?.["Query"] && isTable) {
      showAlertConfirmNotifications({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentKey: `${t("translation:Grid_Picklist_Mandatory_Query")}`
      });
      return false;
    }

    // if (
    //   propertiesJson.ColumnType === "combo" &&
    //   !(propertiesJson?.["DBQuery"] || propertiesJson?.options?.length) &&
    //   props?.data?.elem_type === "table"
    // ) {
    //   showAlertConfirmNotifications({
    //     open: true,
    //     showConfirm: "showNotification",
    //     alertType: "error",
    //     alertContentKey: `${t("translation:Grid_Mandatory_Options")}`
    //   });
    //   return false;
    // }

    if (
      propertiesJson.ColumnMasking && propertiesJson?.complexFieldType &&
      (propertiesJson.ColumnMasking === "password" || propertiesJson.ColumnMasking === "email") &&
      propertiesJson?.complexFieldType !== "String"
    ) {
      showAlertConfirmNotifications({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentKey: `${t("Please select String type data object for selected masking.")}`
      });
      return false;
    }

    if (
      propertiesJson?.complexFieldType &&
        (propertiesJson.ColumnType === "toggle" &&
          !(propertiesJson?.complexFieldType === "boolean" || propertiesJson?.complexFieldType === "Boolean"))
    ) {
      showAlertConfirmNotifications({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentKey: `${t("Toggle should be mapped only with boolean data type.")}`
      });
      return false;
    }

    if (
      propertiesJson?.complexFieldType &&
      ((propertiesJson.ColumnType !== "datepick" &&
        (propertiesJson?.complexFieldType === "shortDate" || propertiesJson?.complexFieldType === "Short Date")) ||
        (propertiesJson.ColumnType === "datepick" &&
          !(propertiesJson?.complexFieldType === "shortDate" || propertiesJson?.complexFieldType === "Short Date")))
    ) {
      showAlertConfirmNotifications({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentKey: `${t("Only date picker should be mapped with short date data type")}`
      });
      return false;
    }

    if (
      propertiesJson?.complexFieldType &&
      ((propertiesJson.ColumnType !== "datetimepick" && propertiesJson?.complexFieldType === "Date") ||
        (propertiesJson.ColumnType === "datetimepick" && propertiesJson?.complexFieldType !== "Date"))
    ) {
      showAlertConfirmNotifications({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentKey: `${t("Only date time picker should be mapped with date data type")}`
      });
      return false;
    }

    if (propertiesJson["ColumnName"] === "id") {
      showAlertConfirmNotifications({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentKey: `${t("translation:No_Column_Name_Id")}`
      });
      return false;
    }

    const columnNameError = checkMandatoryFunction("ColumnName", propertiesJson["ColumnName"]);
    const columnTypeError = checkMandatoryFunction("ColumnType", propertiesJson["ColumnType"]);

    if (columnTypeError || columnNameError) {
      return false;
    }

    if (arg === "Modify") {
      let totalWidthOfNotCurrentColumns = 0;

      Object.keys(columnsStyle).forEach((columnIndex) => {
        const colStyle = columnsStyle[columnIndex].style;

        if (selectedColumn["columnIndex"] != columnIndex) {
          totalWidthOfNotCurrentColumns =
            totalWidthOfNotCurrentColumns + parseInt(colStyle["ColumnWidth"].replace("%", ""));
        }
      });

      const totalWidth = totalWidthOfNotCurrentColumns + parseInt(currentColumnWidth);
      const notAvailableWithCondition1 = totalWidth > 100;

      if (checkAvailableWidth && notAvailableWithCondition1) {
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: `${t("Total Column width should not be greater than 100%.")}`
        });
        return false;
      }

      const otherColumnsName = Object.values(columnsStyle || {})
        .filter((item) => item?.columnIndex !== selectedColumn?.columnIndex)
        .map((item) => item?.style?.ColumnName);

      if (otherColumnsName.includes(propertiesJson?.["ColumnName"]?.trim())) {
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: `${t("translation:COLUMN_EXIST")}`
        });
        return false;
      }
    } else if (arg === "AddAndContinue") {
      const notAvailableWithCondition =
        props.columnsStyle[0]?.style["ColumnWidth"] === ""
          ? parseInt(90 - availableWidth) < parseInt(currentColumnWidth)
          : parseInt(100 - availableWidth) < parseInt(currentColumnWidth);

      if (checkAvailableWidth && notAvailableWithCondition) {
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: `${"Column width should not be greater than available width."}`
        });
        return false;
      }

      const otherColumnsName = Object.values(columnsStyle || {})
        .filter((item) => item?.columnIndex !== selectedColumn?.columnIndex)
        .map((item) => item?.style?.ColumnName);

      if (otherColumnsName.includes(propertiesJson?.["ColumnName"]?.trim())) {
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: `${t("translation:COLUMN_EXIST")}`
        });
        return false;
      }
    }

    return true;
  };

  const updateAvailableWidth = () => {
    let sum = 0;

    Object.keys(columnsStyle).forEach((columnIndex) => {
      const colStyle = columnsStyle[columnIndex].style;

      if (selectedColumn["columnIndex"] != columnIndex) {
        sum = sum + parseInt(colStyle["ColumnWidth"].replace("%", ""));
      }
    });

    sum = sum + parseInt(propertiesJson["ColumnWidth"].replace("%", ""));
    setAvailableWidth(sum);
  };

  async function handleClose(arg) {
    const shouldUpdate = preSavingValidations(arg);

    if (arg === "Modify" && shouldUpdate) {
      try {
        findLayoutJson(formState2, props.data.id);
        let jsonToSend = { opType: 1 };
        const colIndex = getColIndex();
        const remainingURL = "/Properties/modifyColumn";
        const colStyle = propertiesJson;
        const isMenu = props.data?.containerControl === "Menu";
        const isWizard = props.data?.containerControl === "wizard_h" || props.data?.containerControl === "wizard_v";
        const isSideNavigation = props.data?.containerControl === "sidenavigation";

        let stepIndex;
        let subStepIndex;
        let subChildMenuIndex;
        Object.keys(colStyle).forEach((key) => {
          jsonToSend[key] = colStyle[key];
        });
        let isMenu2 = document.querySelector(`#${props.data.id}`).closest(`[elem_type=Menu]`);
        if (isMenu2) {
          stepIndex = document.querySelector(`#${props.data.id}`).closest(`main`).getAttribute("stepIndex");
          subStepIndex = document.querySelector(`#${props.data.id}`).closest(`main`).getAttribute("substepindex");
          subChildMenuIndex = document
            .querySelector(`#${props.data.id}`)
            .closest(`main`)
            .getAttribute("subchildmenuindex");
        }

        if (isMenu || isWizard || isSideNavigation) {
          jsonToSend["opType"] = 3;
          // jsonToSend["stepIndex"] = props?.data?.stepIndex;
          // jsonToSend["subStepIndex"] = props?.data?.subStepIndex || props?.data?.substepIndex;
          // jsonToSend["subChildMenuIndex"] = props?.data?.subChildMenuIndex;
          jsonToSend["stepIndex"] =
            props.data?.containerControl === "wizard_h" ||
            props.data?.containerControl === "wizard_v" ||
            props.data?.containerControl === "sidenavigation"
              ? wizard_type_step
              : props.data?.stepIndex || stepIndex;
          jsonToSend["subStepIndex"] =
            props.data?.containerControl === "wizard_h" ||
            props.data?.containerControl === "wizard_v" ||
            props.data?.containerControl === "sidenavigation"
              ? wizard_type_subStepIndex
              : props.data?.subStepIndex || subStepIndex || subStepIndex == 0
              ? subStepIndex
              : "-1";
          jsonToSend["subChildMenuIndex"] =
            (props.data?.containerControl === "wizard_h" ||
              props.data?.containerControl === "wizard_v" ||
              props.data?.containerControl === "sidenavigation")
              ? wizard_type_subChildMenuIndex
              : (typeof props.data?.subChildMenuIndex !== "undefined"
                ? props.data.subChildMenuIndex
                : (typeof subChildMenuIndex !== "undefined" && subChildMenuIndex !== null)
                  ? subChildMenuIndex
                  : "-1");
        }

        if (openCanvasForSubform === "advanceListviewFromScratch") {
          jsonToSend["isAdvanceListview"] = true;
          jsonToSend["opType"] = 1;
        } else if (openCanvasForSubform === "subform") {
          jsonToSend["isSubForm"] = true;
          jsonToSend["opType"] = 1;
        }

        jsonToSend["FormId"] = `${
          microFrontendData?.formDefId ||
          activePage?.formId ||
          activeSubForm?.fragmentId ||
          microFrontendData?.processDefId ||
          microFrontendData?.templateId
        }`;
        jsonToSend["layoutJson"] = layout;
        jsonToSend["frameIndex"] = props.data.frameIndex;
        jsonToSend["elementIndex"] = props.data.elementIndex;
        jsonToSend["columnIndex"] = parseInt(colIndex);
        jsonToSend["SortingType"] = propertiesJson.SortingType;
        jsonToSend["controlid"] = props?.data?.id;
        jsonToSend["type"] = isMenu ? "menu" : isWizard || isSideNavigation ? "wizard" : undefined;

        if (props.data.sheetElementIndex || props.data.sheetElementIndex === 0) {
          jsonToSend["sheetElementIndex"] = props.data.sheetElementIndex;
          jsonToSend["sheetIndex"] = parseInt(props.data.sheetIndex);
          jsonToSend["opType"] = 2;
        }

        if (props.data.sheetFrameElementIndex || props.data.sheetFrameElementIndex === 0) {
          jsonToSend["sheetFrameElementIndex"] = props.data.sheetFrameElementIndex;
          jsonToSend["opType"] = 4;
        }

        if (jsonToSend["ColumnType"] === "datetimepick") {
          jsonToSend["ColumnType"] = "datetpick";
          jsonToSend["PickerType"] = "2";
        }

        axios
          .post(remainingURL, jsonToSend, { withCredentials: true })
          .then((response) => {
            if (response?.data?.status === "0") {
              setCurrentMappedDO((prev) => {
                const prevData = prev.filter((data) => data !== currentAssociatedFieldData?.treeName)
                const result = [...prevData, ...(currentAssociatedFieldData?.treeName ? [currentAssociatedFieldData.treeName] : [])]
                return [...result];
              });
              props.data.columnList.forEach((col, index) => {
                if (col?.columnIndex == colIndex) {
                  props.data.columnList[index].style = colStyle;
                  props.data.columnList[index].style.isModify = "false";
                }
              });
              jsonToSend = {};

              if (props.data.elem_type === "listview") {
                changeElemType(parseInt(colIndex));
              }

              showAlertConfirmNotifications({
                open: true,
                showConfirm: "showNotification",
                alertType: "success",
                alertContentKey: "MODIFY_SUCCESS",
                autoHideDuration: 2300
              });
              let oldColumnListNames = [...columnNamesList];
              setColumnNamesList([...oldColumnListNames]);
              oldColumnListNames[colIndex] = props.data.columnList[colIndex]?.style?.ColumnName;

              const cloneSelectedColumn = cloneDeep(selectedColumn);
              cloneSelectedColumn.style = Object.assign({}, propertiesJson);
              setColumnsStyle((prev) => {
                return {
                  ...prev,
                  [isNaN(parseInt(cloneSelectedColumn.columnIndex))
                    ? cloneSelectedColumn.columnIndex
                    : parseInt(cloneSelectedColumn.columnIndex)]: cloneSelectedColumn
                };
              });
            }

            if (props.data.elem_type === "listview") {
              props.updateListViewJson(undefined, props.data, dataObjectsContent);
            }
            setOptionAdditionType("Create manually");
            setDecrypt_msg(decrypt_msg_DefaultState);
            modalOpenedFrom.current = "new";
          })
          .catch(() => {
            showAlertConfirmNotifications({
              open: true,
              showConfirm: "showNotification",
              alertType: "error",
              alertContentKey: `Modifying_column_failed`
            });
          });

        setComplexFieldKeysHandler();
        updateAvailableWidth();
        resetState();
        setColumnPropertiesChanged(false);
      } catch (e) {
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: `Modifying_column_failed`
        });
      }
    } else if (arg === "AddAndContinue" && selectedColumn && shouldUpdate) {
      try {
        const cloneSelectedColumn = cloneDeep(selectedColumn);
        cloneSelectedColumn.style = Object.assign({}, propertiesJson);

        updateAvailableWidth();

        const column = {};
        column.frameIndex = props.data.frameIndex;
        column.elementIndex = props.data.frameIndex;
        column.columnIndex = createUniqueId("temp_tableColumn");
        column.style = Object.assign({}, ThemeJSON.tableColumn1);
        column.style["ColumnName"] = propertiesJson["ColumnName"];
        column.style["ColumnWidth"] = columnsStyle?.[0]?.["ColumnWidth"] || "10%";
        column.style["ColumnWidthType"] = columnsStyle?.[0]?.["ColumnWidthType"] || "percentage";

        const remainingURL = "/Properties/addColumn";
        let jsonToSend = {};
        let stepIndex;
        let subStepIndex;
        let subChildMenuIndex;
        let isMenu = document.querySelector(`#${props.data.id}`).closest(`[elem_type=Menu]`);
        if (props.data?.isStep && props.data?.isStep?.insideWizard) {
          jsonToSend["opType"] = 3;
        } else if (isMenu) {
          stepIndex = document.querySelector(`#${props.data.id}`).closest(`main`).getAttribute("stepIndex");
          subStepIndex = document.querySelector(`#${props.data.id}`).closest(`main`).getAttribute("substepindex");
          subChildMenuIndex = document
            .querySelector(`#${props.data.id}`)
            .closest(`main`)
            .getAttribute("subchildmenuindex");
          jsonToSend["opType"] = 3;
        } else {
          jsonToSend["opType"] = 1;
        }

        //    jsonToSend["FormId"] = "5";
        jsonToSend["FormId"] = `${
          microFrontendData?.formDefId ||
          activePage?.formId ||
          activeSubForm?.fragmentId ||
          microFrontendData?.formId ||
          microFrontendData?.processDefId ||
          microFrontendData?.templateId
        }`;
        jsonToSend["layoutJson"] = layout;
        jsonToSend["frameIndex"] = props.data.frameIndex;
        jsonToSend["elementIndex"] = props.data.elementIndex;
        jsonToSend["elem_type"] = "column";
        jsonToSend["stepIndex"] =
          props.data?.containerControl === "wizard_h" ||
          props.data?.containerControl === "wizard_v" ||
          props.data?.containerControl === "sidenavigation"
            ? wizard_type_step
            : formState2?.stepIndex || stepIndex;
        jsonToSend["subStepIndex"] =
          props.data?.containerControl === "wizard_h" ||
          props.data?.containerControl === "wizard_v" ||
          props.data?.containerControl === "sidenavigation"
            ? wizard_type_subStepIndex
            : props.data?.subStepIndex || subStepIndex || subStepIndex == 0
            ? subStepIndex
            : "-1";
        jsonToSend["subChildMenuIndex"] =
          props.data?.containerControl === "wizard_h" ||
          props.data?.containerControl === "wizard_v" ||
          props.data?.containerControl === "sidenavigation"
            ? wizard_type_subChildMenuIndex
            : props.data?.subChildMenuIndex || subChildMenuIndex || subChildMenuIndex == 0
            ? subChildMenuIndex
            : "-1";
        if (openCanvasForSubform === "advanceListviewFromScratch") {
          jsonToSend["isAdvanceListview"] = true;
        } else if (openCanvasForSubform === "subform") {
          jsonToSend["isSubForm"] = true;
        }

        const colStyle = cloneSelectedColumn.style;
        Object.keys(colStyle).forEach((key) => {
          jsonToSend[key] = colStyle[key];
        });
        if (Object.keys(props.data).includes("sheetElementIndex") && props.data.sheetElementIndex !== undefined) {
          jsonToSend["sheetElementIndex"] = props.data.sheetElementIndex;
          jsonToSend["sheetIndex"] = parseInt(props.data.sheetIndex);
          jsonToSend["opType"] = 2;
        }
        if (
          Object.keys(props.data).includes("sheetFrameElementIndex") &&
          props.data.sheetFrameElementIndex !== undefined
        ) {
          jsonToSend["sheetFrameElementIndex"] = props.data.sheetFrameElementIndex;
          jsonToSend["opType"] = 4;
        }
        if (jsonToSend["ColumnType"] === "datetimepick") {
          jsonToSend["ColumnType"] = "datepick";
          jsonToSend["PickerType"] = "2";
        }
        if (openCanvasForSubform === "subform") {
          jsonToSend["isSubForm"] = "true";
        }

        jsonToSend.SortingType = propertiesJson.SortingType;

        jsonToSend["isModify"] = "false";
        jsonToSend["controlid"] = props?.data?.id;
        if (props.data?.containerControl) {
          if (props.data?.containerControl === "Menu") {
            jsonToSend["type"] = "menu";
          }
          if (
            props.data?.containerControl === "wizard_h" ||
            props.data?.containerControl === "wizard_v" ||
            props.data?.containerControl === "sidenavigation"
          ) {
            jsonToSend["type"] = "wizard";
          }
        }
        axios
          .post(remainingURL, jsonToSend, { withCredentials: true })
          .then((response) => {
            if (response?.data?.status === 0) {
              setCurrentMappedDO((prev) => {
                const result = [...prev, ...(currentAssociatedFieldData?.treeName ? [currentAssociatedFieldData.treeName] : [])]
                return [...result];
              });
              const colDetails = {};
              colDetails["FormId"] = activePage?.formId || activeSubForm?.fragmentId;
              colDetails["frameIndex"] = props.data.frameIndex;
              colDetails["elementIndex"] = props.data.elementIndex;
              colDetails["elem_type"] = "column";
              colDetails["columnIndex"] = response.data.columnIndex;
              colDetails["elementJson"] = response.data.elementJson;

              if(colDetails["elementJson"] && jsonToSend.controlName === "richtexteditor") {
                colDetails["elementJson"].controlName = "richtexteditor";
              }

              colDetails.style = { ...cloneSelectedColumn.style };

              if (response.data.elementJson) {
                if (
                  response.data.elementJson.controlName === "listbox" ||
                  response.data.elementJson.controlName === "radio" ||
                  response.data.elementJson.controlName === "combo"
                ) {
                  colDetails["elementJson"]["options"] = jsonToSend.options;
                }
              }
              cloneSelectedColumn.columnIndex = column.columnIndex;

              setColumnNamesList((prev) => [...prev, column.style["ColumnName"]]);
              setColumnsStyle((prev) => {
                return { ...prev, [column.columnIndex]: cloneSelectedColumn };
              });
              setBufferToCheck({ ...bufferToCheck, [column.columnIndex]: { toggle: false } });
              setDisableButton(true);
              props.data.columnList.push(colDetails);
              if (props.data.elem_type === "listview") {
                props.updateListViewJson(undefined, props.data, dataObjectsContent);
              }
              setOptionAdditionType("Create manually");
              setDecrypt_msg(decrypt_msg_DefaultState);
              updatedComponentInFormState(props.data.id, props.data);
            } else if (response.data.status === 1) {
              showAlertConfirmNotifications({
                open: true,
                showConfirm: "showNotification",
                alertType: "error",
                alertContentKey: "Reopen_Form"
              });
            }
          })
          .catch(() => {
            showAlertConfirmNotifications({
              open: true,
              showConfirm: "showNotification",
              alertType: "error",
              alertContentKey: "Adding new column failed"
            });
          });

        setComplexFieldKeysHandler();
        const ColumnWidthType = columnsStyle?.[0]?.style?.["ColumnWidthType"] || "percentage";
        const columnNew = {};
        columnNew.frameIndex = props.data.frameIndex;
        columnNew.elementIndex = props.data.frameIndex;
        columnNew.columnIndex = createUniqueId("temp_tableColumn");
        columnNew.style = Object.assign({}, ThemeJSON.tableColumn1);
        columnNew.style["ColumnName"] = "";
        columnNew.style["ColumnWidth"] = ColumnWidthType === "percentage" ? "10%" : "100px";
        columnNew.style["ColumnWidthType"] = ColumnWidthType;
        setSelectedColumn(columnNew);
        setPropertiesJson(columnNew.style);
        resetState();
      } catch (e) {
        console.log("Add/Modify Column::" + e);
      }
    } else if (props?.data) {
      props.setShowTableBackdrop(arg);
      updatedComponentInFormState(props.data.id, props.data);
    }
    if (arg === false) {
      setIsTableBackdropOpen(false);
    }
  }

  function handleColumn(columnIndex, isModified) {
    try {
      modalOpenedFrom.current = "edit";
      let flag = false;

      let stateUpdated = {};
      Object.keys(bufferToCheck).forEach((item) => {
        if (item == columnIndex) {
          stateUpdated[item] = {
            ...bufferToCheck[item],
            toggle: !bufferToCheck[item].toggle
          };
        } else {
          stateUpdated[item] = {
            ...bufferToCheck[item],
            toggle: false
          };
        }
      });

      setBufferToCheck(() => stateUpdated);

      if (
        columnsStyle &&
        Object.keys(columnsStyle) &&
        Object.keys(columnsStyle).includes(selectedColumn.columnIndex + "")
      ) {
        const tempCol = columnsStyle[selectedColumn.columnIndex];
        setColumnsStyle((prev) => {
          return { ...prev, [selectedColumn.columnIndex]: tempCol };
        });
      }

      let selectedColumnStyle = {};

      Object.keys(columnsStyle).forEach((col) => {
        if (columnsStyle[col].columnIndex === columnIndex) {
          setSelectedColumn(columnsStyle[col]);
          setCurrentColumnWidth(columnsStyle[col]?.style?.["ColumnWidth"]?.replace("%", ""));

          const propertiesToResrt = resetProperties();
          setPropertiesJson({ ...columnsStyle[col].style, ...propertiesToResrt });

          selectedColumnStyle=columnsStyle[col].style;
        }
      });

      flag = Object.keys(stateUpdated).reduce((acc, curr) => {
        return (acc = acc || stateUpdated[curr].toggle);
      }, false);

      if (!flag) {
        resetState();
      }
      setMandatoryErrors({ columnName: false, columnType: false });
      setColumnPropertiesChanged(false);
      setOptionAdditionType(
        selectedColumnStyle.addOptionsMethod === "database" ? "Fetch from database" : "Create manually"
      );
      setSessionOption("")
    } catch (e) {
      //customalert
      console.log(e);
    }
  }

  const resetState = () => {
    const ColumnWidthType = columnsStyle?.[0]?.style?.["ColumnWidthType"] || "percentage";

    const column = {};
    column.frameIndex = props.data.frameIndex;
    column.elementIndex = props.data.frameIndex;
    column.columnIndex = createUniqueId("temp_tableColumn");
    column.style = Object.assign({}, ThemeJSON.tableColumn1);
    column.style["ColumnName"] = "";
    column.style["ColumnWidth"] = ColumnWidthType === "percentage" ? "10%" : "100px";
    column.style["ColumnWidthType"] = ColumnWidthType;

    setSelectedColumn(column);
    setCurrentColumnWidth(column?.style?.["ColumnWidth"]?.replace("%", ""));
    setPropertiesJson(column.style);
    setDisableButton(true);
  };

  return (
    <>
      <Backdrop id={props.key} className={classes.backdrop} open={true}>
        <div
          tabIndex="0"
          onKeyDown={(e) => handleEscapeKey(e)}
          id="backdropDiv"
          className={styles.backdropDiv}
          style={{ height: "449px" }}
        >
          <div className={styles.backdropHeaderDiv}>
            <div className={styles.headerLeft}>{t(`translation:Add Column(s)`)}</div>
            <div className={styles.headerRight}></div>
          </div>

          <hr className={styles.hrTagBackdrop}/>
          <div className={styles.backdropBodyDiv} style={translationStyles1 ? { display: "flex" } : null}>
            <div className={styles.backdropBodyLeftPart}>
              <div className={styles.backdropBodyLeftPartColumnListText}>{t(`translation:List of Columns`)}</div>

              <div className={styles.backdropBodyOverflow}>
                {selectedColumn &&
                  props.data &&
                  props.data.columnList &&
                  Object.keys(columnsStyle).map((key) => {
                    if (key && columnsStyle[key]) {
                      return (
                        <>
                          <div
                            id={columnsStyle[key].columnIndex}
                            className={
                              columnsStyle[key].columnIndex === selectedColumn.columnIndex
                                ? styles.backdropBodyLeftPartColumnListOddRowSelected
                                : styles.backdropBodyLeftPartColumnListOddRow
                            }
                            onClick={() => handleColumn(columnsStyle[key].columnIndex)}
                          >
                            <span className={styles.backdropBodyLeftPartColumnListColumnName}>
                              {columnsStyle[key].style.ColumnName}
                            </span>

                            <span className={styles.backdropBodyLeftPartColumnListColumnWidth}>
                              {columnsStyle[key].style.columnWidth !== "" ? columnsStyle[key].style.columnWidth : null}
                            </span>
                          </div>
                        </>
                      );
                    }
                  })}
              </div>
            </div>

            <div className={styles.backdopBodyRightPart} style={translationStyles1 ? { paddingLeft: "10px" } : {}}>
              {props.data && selectedColumn && selectedColumn !== null ? (
                <TableBackdropColumnDetails
                  key={selectedColumn.columnIndex}
                  selectedColumn={selectedColumn}
                  CollapsibleItems={CollapsibleItems}
                  BasicDetailsLeftSide={BasicDetailsLeftSide}
                  BasicDetailsRightSide={BasicDetailsRightSide}
                  BasicDetailsBottom={BasicDetailsBottom}
                />
              ) : null}
            </div>
          </div>

          <div
            id="footer"
            className={styles.colButtonDiv}
            style={
              translationStyles1
                ? { display: "flex", flexDirection: "row-reverse", height: "46px" }
                : { height: "46px" }
            }
          >
            <Button
              disableFocusRipple
              disableRipple
              tabIndex={0}
              className={`formBuilder-MuiButton-outlined ${styles.addColumnAndContinueButton}`}
              onClick={() => handleClose("Modify")}
              disabled={!(modalOpenedFrom.current === "edit" && columnPropertiesChanged)}
            >
              {t(`translation:Modify`)}
            </Button>

            <Button
              disableFocusRipple
              disableRipple
              tabIndex={0}
              className={`formBuilder-MuiButton-outlined ${styles.addColumnAndContinueButton}`}
              disabled={
                !disableButton && (modalOpenedFrom.current === "edit" || selectedColumn.style.ColumnName !== "")
              }
              onClick={() => handleClose("AddAndContinue")}
            >
              {t(`translation:Add Column and Continue`)}
            </Button>

            <Button
              disableFocusRipple
              disableRipple
              tabIndex={0}
              className={`${styles.cancelBackdropButton} tertiary formBuilder-MuiButton-outlined`}
              onClick={() => handleClose(false)}
            >
              {t(`translation:Close`)}
            </Button>
          </div>
        </div>
      </Backdrop>
    </>
  );
}
export default TableBackdrop;